import React, { useEffect, useState, ChangeEvent, useRef, HtmlHTMLAttributes, useMemo } from "react";
import {
    TextField,
    Grid,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    Button,
    InputAdornment,
    IconButton,
    Typography,
    Box,
    Stack,
    Modal,
    Divider,
    SvgIcon,
    Autocomplete,
    Switch,
    CircularProgress,
    TextareaAutosize,
    Tooltip,
    Collapse,
    Paper,
    FormControlLabel,
    Checkbox,
    LinearProgress,
    RadioGroup,
    Radio
} from "@mui/material";
import { AudioItem, VideoItem, DocumentItem, CourseDetails, GetCourseDetailsResponse } from "redux/api/types";
import MicIcon from "@mui/icons-material/Mic";
import EditIcon from "@mui/icons-material/Edit";
import SendIcon from "@mui/icons-material/Send";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import Header from "../../../components/headers/Header";
import Ocesha_header from "pages/ocesha_landing/ocesha_header";
import AddIcon from '@mui/icons-material/Add';
import '../generated_blogs.css';
import './CreateCourse.module.css';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ReactComponent as CardIcon } from '../../../assets/card_ico.svg';
import { ReactComponent as TwitterIcon } from '../../../assets/traffic_monster/icon_twitter.svg';
import { ReactComponent as PinterestIcon } from '../../../assets/traffic_monster/pinterest_ico.svg';
import { ReactComponent as FacebookIcon } from '../../../assets/traffic_monster/fb_ico.svg';
import { ReactComponent as LinkedinIcon } from '../../../assets/traffic_monster/linkedIn_ico.svg';
import { ReactComponent as StepArrowIcon } from '../../../assets/img/vector-5-2.svg';
import bulletChecked from "../../../assets/img/vector-8-1.svg";
import { CheckBox, FormatColorFill, Height, Widgets } from "@mui/icons-material";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { ReactComponent as VerifiedIcon } from '../../../assets/verified_ico.svg';
import { isBrowser, isMobile } from "react-device-detect";
import { useCreateCampaignMutation } from "../../../redux/api/promptApi";
import { toast } from "react-toastify";
import { useLazyCreateCheckoutSessionQuery } from "../../../redux/api/subscriptionApi";
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { usePlanDetailsMutation, useCampaignDetailsMutation } from "../../../redux/api/productApi";
import { useGetUserDetailsMutation } from "../../../redux/api/authApi";
import { useLocation, useNavigate } from "react-router-dom";
import { useGetpagefrocampaignMutation, useGetCnameEntriesMutation, useUpdateAutoPublishFlagMutation, useGetverifyscriptMutation, useCheckverifiedMutation } from "../../../redux/api/promptApi";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import { id } from "date-fns/locale";
import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { IPlanDetail } from "../../../redux/api/types";
import { useLazyGetProductQuery } from '../../../redux/api/productApi';
import { useAppSelector } from '../../../redux/store';
import { ReactComponent as Twitterico } from '../../../assets/traffic_monster/twitter__ico.svg';
import { ReactComponent as Pinterestico } from '../../../assets/traffic_monster/pinterest__ico.svg';
import { ReactComponent as Fbico } from '../../../assets/traffic_monster/fb__ico.svg';
import { ReactComponent as Linkedinico } from '../../../assets/traffic_monster/linkedin__ico.svg';
import axios from 'axios';
import { useCampaignListMutation } from "../../../redux/api/promptApi";
import InfoIcon from '@mui/icons-material/Info';
import YouTubeIcon from '@mui/icons-material/YouTube';
import youtubeIco1 from '../../../assets/traffic_monster/youtubeIco_1.png'
import { upload } from "@testing-library/user-event/dist/upload";
import ProgressBar from "@ramonak/react-progress-bar";
import { setCookie, getCookie, removeCookie } from '../../../utils/storageUtils';
import { urPK } from "@mui/x-date-pickers";
import { useAppDispatch } from "../../../redux/store";
import { logout } from "redux/features/userSlice";
import ocesha_logo from '../../../assets/ocesha_images/ocesha_logo.png';
import { ReactComponent as BlogsIco } from '../../../assets/ocesha_images/blogs_ico.svg';
import { ReactComponent as VideoIco } from '../../../assets/ocesha_images/video_ico.svg';
import { ReactComponent as AudioIco } from '../../../assets/ocesha_images/audio_ico.svg';
import { ReactComponent as ImagesIco } from '../../../assets/ocesha_images/images_ico.svg';
import { ReactComponent as EpisodeIco } from '../../../assets/ocesha_images/episode_ico.svg';
import { ReactComponent as ClipIco } from '../../../assets/ocesha_images/clip_ico.svg';
import { ReactComponent as TeamIco } from '../../../assets/ocesha_images/team_ico.svg';
import { ReactComponent as IntegrationIco } from '../../../assets/ocesha_images/integration_ico.svg';
import { ReactComponent as UpgradeIco } from '../../../assets/ocesha_images/upgrade_ico.svg';
import { ReactComponent as BillingIco } from '../../../assets/ocesha_images/billing_ico.svg';
import { ReactComponent as SettingsIco } from '../../../assets/ocesha_images/settings_ico.svg';
import { ReactComponent as HelpIco } from '../../../assets/ocesha_images/help_ico.svg';
import { ReactComponent as LogoutIco } from '../../../assets/ocesha_images/logout_ico.svg';
import { ReactComponent as DashboardIco } from '../../../assets/ocesha_images/dashboard_ico.svg';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import MicOffIcon from "@mui/icons-material/MicOff";
import RohanImg from '../../../assets/podcast_monster/rohan_png.png';
import MicNoneOutlinedIcon from '@mui/icons-material/MicNoneOutlined';
import VolumeOffOutlinedIcon from '@mui/icons-material/VolumeOffOutlined';
import VolumeUpOutlinedIcon from "@mui/icons-material/VolumeUpOutlined";
import { ReactComponent as EditIco } from '../../../assets/podcast_monster/edit_ico.svg';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
/* import { TTSButton } from "../../../components/TTSPlayer";
import { speakText, stopTTS } from "../../../redux/features/ttsSlice"; */
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import FolderIcon from "@mui/icons-material/Folder";
/* import { TTSButton } from "../../../components/TTSPlayer";
import { speakText } from "../../../redux/features/ttsSlice"; */
import InsightsIcon from "@mui/icons-material/Insights";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import { useTTSQueue } from "hooks/useTTSQueue";
import { audioManager } from "utils/globalAudioManager";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CheckIcon from "@mui/icons-material/Check";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { saveVoiceSample } from "utils/digitalTwinVoice";


// ─── Digital Twin API hooks ───────────────────────────────────────────────────
import {
    useStartInterviewMutation,
    useAnswerQuestionMutation,
    useExtractAuthorityMutation,
    useGenerateBlueprintMutation,
    useStartInterviewTriggerMutation,
    useLazyGetTaskStatusQuery,

} from "../../../redux/api/digitalTwinApi";
import { getGreetingUrl, localizedClipUrl } from "../../../utils/voiceClips";
// intro clip in the site language (falls back to the English WAV)
const localizedIntro = { current: "" };

// ─── Types ────────────────────────────────────────────────────────────────────

interface SessionEntry {
    question: string;
    answer: string;
    stage: string;
    audio_path?: string;
}

const ONBOARDING_QUESTIONS = [
    {
        id: 1,
        text: "Tell me your name and a bit about who you are.",
        isCompleted: true,
    },
    {
        id: 2,
        text: "What topics do you speak or teach about?",
        isCompleted: true,
    },
    {
        id: 3,
        text: "Who do you help or who is your audience?",
        isCompleted: false,
    },
    {
        id: 4,
        text: "What results do you help people achieve?",
        isCompleted: false,
    },
    {
        id: 5,
        text: "What type of courses would you love to create if it were easy?",
        isCompleted: false,
    },
];

const COURSE_STEPS = [
    {
        number: "01",
        title: "Share your\nExpertise",
        isActive: true,
    },
    {
        number: "02",
        title: "Upload Content\nto Train",
        isActive: false,
    },
    {
        number: "03",
        title: "Choose your\nCourse Topic",
        isActive: false,
    },
    {
        number: "04",
        title: "Generate your\nCourse",
        isActive: false,
    },
];

interface ErrorResponse {
    error: {
        status: number;
        data: {
            detail: string;
        };
    };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: 'lightblack',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
        color: 'black',
    },
    '&:nth-of-type(even)': {
        backgroundColor: '#F2F6FA',
        color: 'darkslategray',
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const HeaderCell = styled('div')(({ theme }) => ({
    color: '#626F86',
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '12px',
    textAlign: 'center',
    '&:nth-child(odd)': {
        backgroundColor: '#EAECF0',
    },
    '&:nth-child(even)': {
        backgroundColor: '#F5F5F5',
    }
}));

const DataCell = styled('div')(({ theme }) => ({
    color: '#344054',
    fontSize: '14px',
    padding: '12px',
    textAlign: 'center',
    '&:nth-child(odd)': {
        backgroundColor: '#EAECF0',
    },
    '&:nth-child(even)': {
        backgroundColor: '#F5F5F5',
    }
}));

export const retryAsync = async <T,>(
  fn: () => Promise<T>,
  retries = 2,
  delay = 1500,
  validate?: (result: T) => boolean
): Promise<T> => {
  try {
    const result = await fn();

    // custom validation (like empty courses)
    if (validate && !validate(result)) {
      if (retries <= 0) throw new Error("Validation failed");

      console.log("Retrying due to empty/invalid response...");
      await new Promise((res) => setTimeout(res, delay));

      return retryAsync(fn, retries - 1, delay, validate);
    }

    return result;
  } catch (err) {
    if (retries <= 0) throw err;

    console.log(`Retrying... attempts left: ${retries}`);
    await new Promise((res) => setTimeout(res, delay));

    return retryAsync(fn, retries - 1, delay, validate);
  }
};

//const TOTAL_QUESTIONS = 6;
const TOTAL_QUESTIONS = 3;


const New_Course = () => {

    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useAppDispatch();

    const storedSessionId = localStorage.getItem('dt_session_id');
    const storedQuestion  = localStorage.getItem('dt_current_question');
    const storedHistory   = JSON.parse(localStorage.getItem('dt_session_history') || '[]');
    

    const { FromEdit } = location.state || {};
    const { campIdFrEdit } = location.state || {};
    const { subscriptionFromCampList } = location.state || {};
    const { subscriptionTH } = location.state || {};
    const { mode } = location.state || {};
    const FromSignUp = location.state?.FromSignUp || '';
    const transcribedText = location.state?.transcribedText || '';

    const [sourceUrl, setSourceUrl] = useState<string>((localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('UrlfromLanding')) ? localStorage.getItem('UrlfromLanding') || '' : '');
    const [blogcount, setBlogCount] = useState<any>(1);
    const [sourceYoutubeUrl, setSourceYoutubeUrl] = useState<any>((localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('YoutubeUrlfromLanding')) ? localStorage.getItem('YoutubeUrlfromLanding') || '' : '');
    const [sourceText, setSourceText] = useState<string>('');
    const [videoTag, setVideoTag] = useState<string>(sourceYoutubeUrl || '');
    const [twitterUrl, settwitterUrl] = useState<string>('');
    const [fbUrl, setfbUrl] = useState<string>('');
    const [pintrestUrl, setPintrestUrl] = useState<string>('');
    const [linkedinUrl, setLinkedinUrl] = useState<string>('');
    const [ctaLabel, setCtaLabel] = useState<string>('');
    const [ctaLink, setCtaLink] = useState<string>('');
    const [isEditing, setIsEditing] = useState(false);

    const [expertise, setExpertise] = useState<string>(localStorage.getItem('expertise') || "");
    const [isRecordingExpertise, setIsRecordingExpertise] = useState(false);
    const [isRecordingQuestion, setIsRecordingQuestion] = useState(false);
    const mediaRecorderRef = useRef<MediaRecorder | null>(null);
    const audioChunksRef = useRef<BlobPart[]>([]);

    const [isListening, setIsListening] = useState(false);
    const textareaRef = useRef<HTMLTextAreaElement | null>(null);
    const recognitionRef = useRef<any>(null);

    const [campaignName, setCampaignName] = useState<string>('');
    const [urlPrefix, setUrlPrefix] = useState<string>((localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('YoutubeUrlfromLanding')) ? 'youtubeid' : (localStorage.getItem('ErrorAlert') === 'true' && localStorage.getItem('UrlfromLanding')) ? 'https://' : 'https://');
    const [expanded, setExpanded] = useState(true);
    const [expanded1, setExpanded1] = useState(true);
    const [expanded2, setExpanded2] = useState(false);
    const [expanded3, setExpanded3] = useState(false);
    const [expanded4, setExpanded4] = useState(false);
    const [expanded5, setExpanded5] = useState(false);
    const [expanded6, setExpanded6] = useState(false);
    const [expanded7, setExpanded7] = useState(false);
    const [expanded8, setExpanded8] = useState(false);
    const [expanded9, setExpanded9] = useState(false);
    const [expanded10, setExpanded10] = useState(false);
    const [expanded11, setExpanded11] = useState(false);
    const [expanded12, setExpanded12] = useState(false);
    const [expanded14, setExpanded14] = useState(false);
    const [expanded15, setExpanded15] = useState(false);
    const [expanded13, setExpanded13] = useState(false);
    const [planDetails, setPlanDetails] = useState<any>();
    const [campDetails, setCampDetails] = useState<any>();
    const [defaultPlanDetails, setDefaultPlanDetails] = useState<any>();
    const [campaignId, setCampaignId] = useState<any>();
    const [userDetails, setUserDetails] = useState<any>();
    const [openpaymentInstructModal, setOpenPaymentInstructModal] = useState<boolean>(false);
    const [paymentOption, setPaymentOption] = useState<any>();
    const [paymentOptYearlyCal, setPaymentOptYearlyCal] = useState<any>();
    const paymentSectionRef = useRef<HTMLDivElement>(null);
    const getcnameEntriesRef = useRef<HTMLDivElement>(null);
    const getVerifyScript = useRef<HTMLDivElement>(null);
    const [autoPublish, setAutopublish] = useState<any>(false);
    const [publishToOcesha, setPublishToOcesha] = useState<any>(false);
    const [publishToCodegenie, setPublishToCodegenie] = useState<any>(false);
    const [competitorSearch, setCompetitorSearch] = useState<any>(false);
    const [limitPublish, setLimitPublish] = useState<any>(true);
    const [socialMediaUrlPublish, setSocialMediaUrlPublish] = useState<any>();
    const [addtags, setAddTags] = useState<any>(true);
    const [externalLinks, setExternalLinks] = useState<any>(true);
    const [toc, setToc] = useState<any>(true);
    const [capturleads, setCapturLeads] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [newsletter, setNewsLetter] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [twitternbutton, setTwitternButton] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [fbbutton, setFbButton] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [pintrestbutton, setPintrestButton] = useState<any>(true);
    const [linkedinbutton, setLinkedinButton] = useState<any>(!!planDetails?.embed_contact_form_newsletters_social_media_share);
    const [video, setVideo] = useState<any>(!!planDetails?.embed_youtube_video);
    const [useOwnDomain, setUseOwnDomain] = useState<any>(false);
    const [isloadingGetPage, setIsLoadingGetPage] = useState<boolean>(false);
    const [openGetPagesuccessModal, setOpenGetPageSuccessModal] = useState<boolean>(false);
    const [confirmCancelSubscription, setConfirmCancelSubscription] = useState<boolean>(false);
    const [cnameRecords, setCnameRecords] = useState<any>();
    const [cnameDomainName, setCnameDomainName] = useState<any>();
    const [isLoadingCnameRec, setIsLoadingCnameRec] = useState<boolean>(false);
    const getpageRunref = useRef(false);
    const [script, setScript] = useState<any>();
    const [verifyCheck, setVerifyCheck] = useState<any>();
    const [period, getPeriodState] = useState("monthly");
    const [createCampaignMutation] = useCreateCampaignMutation();
    const user_email = localStorage.getItem('user_email') || getCookie('user_email') || '';
    const [isUpdateLoader, setIsUpdateLoader] = useState<boolean>(false);
    const [selectedSubscriptionLevel, setSelectedSubscriptionLevel] = useState<string>('');
    const [isLoadingCourse, setIsLoadingCourse] = useState(false);
    const hasStartedRef = useRef(false);

    const [isContentOpen, setIsContentOpen] = useState(false);
    const [getProduct, getState] = useState<any>();
    const [plans, setPlans] = useState<IPlanDetail[]>([
        {
            user: 1,
            plan_name: "",
            total_wishes: 0,
            price: "",
            period: "",
            product_id: "",
            price_id: "",
            subscription_level: "",
            feature: [],
            contracts: 0,
            type: "",
            button_text: "",
            save: ''
        },
    ]);
    const [productModule, setProductModule] = useState("");
    const genieSelector = useAppSelector((state) => state.genieState);

    const [createCheckoutSession, checkoutState] = useLazyCreateCheckoutSessionQuery();
    const [getUserDetailsMutation] = useGetUserDetailsMutation();

    const [getuserPlanDetails] = usePlanDetailsMutation();
    const [getuserCampDetails] = useCampaignDetailsMutation();
    const [getPageforCampaign] = useGetpagefrocampaignMutation();
    const [getCnameEntriesMutation] = useGetCnameEntriesMutation();
    const [getverifyscript] = useGetverifyscriptMutation();
    const [getcheckverified] = useCheckverifiedMutation();
    const [updateAutoPublishCheckMutation] = useUpdateAutoPublishFlagMutation();

    const [userImage, setUserImage] = useState<File | null>(null);
    const [userImageUrl, setUserImageUrl] = useState('');
    const [socialUrl, setSocialUrl] = useState('');
    const [name, setName] = useState('');
    const [useAsDefault, setUseAsDefault] = useState(false);
    const [cancellingLoader, setCancellingLoader] = useState<boolean>(false);
    const [campaignListMutation] = useCampaignListMutation();
    const [campaignDatas, setCampaignDatas] = useState<any>();
    const [couponCode, setCouponCode] = useState<string>('');
    const [successCancelSubscription, setSuccessCancelSubscription] = useState(false);
    const [podcastoryoutubeurl, setPodcastOrYoutubeUrl] = useState('');
    const [selectedSection, setSelectedSection] = useState('websiteSection');
    const [uploadVideo, setUploadVideo] = useState('');
    const [isUploadLoading, setIsUploadLoading] = useState(false);
    const [uploadedvideopath, setUploadedvideopath] = useState('');
    const [getPageError, setGetPageError] = useState(false);
    const [loaderProgress, setLoaderProgress] = useState<any>(4);
    const [userBusinessText, setUserBusinessText] = useState('');
    const [upgradeModal, setUpgradeModal] = useState<boolean>(false);
    const [questionText, setQuestionText] = useState<string>("");
    const [chatMessages, setChatMessages] = useState<any[]>([]);
    const [isChatLoading, setIsChatLoading] = useState(false);
    const [isTranscribing, setIsTranscribing] = useState(false);
    const [lastBotText, setLastBotText] = useState<string>("");
    const prevTextRef = useRef("");

    const chatScrollRef = useRef<HTMLDivElement | null>(null);

    const [loadingText, setLoadingText] = useState<any>(
        <Typography fontSize="18px">
            <b>Analyzing Your Content</b>
            <br />
            We're using AI Agents to read through your content, analyze your content, and will suggest some ideas that we can write about
        </Typography>
    );
    const [intervaltime, setIntervalTime] = useState(4000);
    const handleCouponTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setCouponCode(event.target.value);
    };
    const [helpervideosrc, setHelperVideoSrc] = useState<any>();
    const [helperPopup, setHelperPopup] = useState<boolean>(false);
    const [isScrapcheckloading, setIsScrapcheckloading] = useState<boolean>(false);
    const [activeItem, setActiveItem] = useState(localStorage.getItem('activeItem') || 'dashboard');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [topics, setTopics] = useState<any>();
    const [topicsList, setTopicsList] = useState<boolean>(false);
    const [selectedTopic, setSelectedTopic] = useState<any>();
    const [keywords, setKeywords] = useState<any>();
    const [keywordsList, setKeywordsList] = useState<boolean>(false);
    const [selectedKeyword, setSelectedKeyword] = useState<any>();
    const [isKeywordLoader, setIsKeywordLoader] = useState<boolean>(false);

    // ─── Digital Twin interview state ─────────────────────────────────────────
    const [sessionHistory, setSessionHistory] = useState<SessionEntry[]>(() => {
        try {
            return JSON.parse(localStorage.getItem('dt_session_history') || '[]');
        } catch {
            return [];
        }
    });
    const [currentAudioPath, setCurrentAudioPath] = useState<string>("")
    const [currentQuestion, setCurrentQuestion] = useState<string>(
        localStorage.getItem('dt_current_question') || ''
    );
    const [currentStage, setCurrentStage] = useState<string>(
        localStorage.getItem('dt_current_stage') || 'course_topic'
    );
    const [sessionId, setSessionId] = useState<string>(
        localStorage.getItem('dt_session_id') || ''
    );
    const [viewIndex, setViewIndex] = useState<number | null>(null);
    const [interviewDone, setInterviewDone] = useState(false);
    const [isStarting, setIsStarting] = useState(false);
    const [isAnswering, setIsAnswering] = useState(false);
    const [movingPrev, setMovingPrev] = useState<boolean>(false);

    // ─── Digital Twin API mutations ───────────────────────────────────────────
    //const [startInterview] = useStartInterviewMutation();
    const [startInterviewTrigger] = useStartInterviewTriggerMutation();
    const [getTaskStatus] = useLazyGetTaskStatusQuery();
    const [answerQuestion] = useAnswerQuestionMutation();
    const [extractAuthority] = useExtractAuthorityMutation();
    const [generateBlueprint] = useGenerateBlueprintMutation();

    // ─── Persist helpers ──────────────────────────────────────────────────────
    const persistSession = (
        sid: string,
        q: string,
        stage: string,
        hist: SessionEntry[],
        audioPath: string = ""
    ) => {
        localStorage.setItem('dt_session_id', sid);
        localStorage.setItem('dt_current_question', q);
        localStorage.setItem('dt_current_stage', stage);
        localStorage.setItem('dt_current_audio_path', audioPath);
        localStorage.setItem('dt_session_history', JSON.stringify(hist));
    };

    // intro speaker
    // const audioRef = useRef<HTMLAudioElement | null>(null);
    const [isMuted, setIsMuted] = useState(false);
    const hasFetched = useRef(false);
    const shouldPlayQuestion = useRef(false);
    const [introDone, setIntroDone] = useState(false);
    const [currentAudioType, setCurrentAudioType] = useState<"intro" | "question" | "tts" | null>(null);

    // questionnaire speaker
    const [isExpertiseMuted, setIsExpertiseMuted] = useState(false);
    const expertiseAudioRef = useRef<HTMLAudioElement | null>(null);
    const questionAudioRef = useRef<HTMLAudioElement | null>(null); 

    const {
        playText,
        pause,
        resume,
        stop,
        stopAll,
        isPlaying,
        audioRef,
    } = useTTSQueue();


    useEffect(() => {
        // On every page load, nuke any audio leaking from a previous route
        stopAll();
        document.querySelectorAll("audio").forEach(a => {
          try { a.pause(); a.currentTime = 0; a.src = ""; } catch {}
        });
        return () => {
          stopAll();   // and again on the way out
        };
      }, []);

    
    // ─── On mount: start or resume interview ──────────────────────────────────
    useEffect(() => {
        stopAllAudio();

        const init = async () => {
            console.log("dt_session_id", localStorage.getItem('dt_session_id'));
            if (hasStartedRef.current) return;
            hasStartedRef.current = true;

            // Fresh hand-off from New_Course_2: question + session exist, no answers yet.
            // Skip resume — state is already hydrated from localStorage.
            if (storedSessionId && storedQuestion && storedHistory.length === 0) {
                const cachedAudio = localStorage.getItem('dt_current_audio_path');
                if (cachedAudio) setCurrentAudioPath(cachedAudio);
                return;
            }

            if (storedSessionId) {
                await resumeInterview(storedSessionId);
                return;
            }
            await doStartInterview();
        };
        init();

        return () => {
            console.log("Component unmounted → stopping audio");

            stopAllAudio(); // ✅ STOP on unload
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /*const resumeInterview = async (sid: string) => {
        try {
            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            const res = await axios.get(
                `${apiUrl}/api/digital-twin/interview/resume/${sid}`
            );

            if (res.data.status === "interview_completed") {
                setInterviewDone(true);

                // Get previous (last answered)
                const res = await axios.get(
                    `${apiUrl}/api/digital-twin/interview/previous/${sid}`
                );

                console.log("resume called",res.data);

                const data = res.data;

                setViewIndex(data.question_index);   // enter history mode
                setCurrentQuestion(data.question);   // last answered question
                setExpertise(data.answer || "");     // last answer
                return;
            }

            setSessionId(res.data.session_id);
            setCurrentQuestion(res.data.question);
            setCurrentStage(res.data.stage);

        } catch (err) {
            console.error("Resume failed", err);

            // fallback → start new only if resume fails
            await doStartInterview();
        }
    };*/

   

    const resumeInterview = async (sid: string) => {
        const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

        // Get previous (last answered)
        const res = await axios.get(
            `${apiUrl}/api/digital-twin/interview/previous/${sid}`
        );

        const data = res.data;

        // ADD THIS CHECK
        if (data.status === "interview_completed") {
            setInterviewDone(true);
            // Park them on the last answered question explicitly
            const hist: SessionEntry[] = JSON.parse(
                localStorage.getItem('dt_session_history') || '[]'
            );
            if (hist.length > 0) {
                setViewIndex(hist.length - 1);
                setCurrentQuestion(hist[hist.length - 1].question);
                setExpertise(hist[hist.length - 1].answer || '');
                setCurrentStage(hist[hist.length - 1].stage);
                setSessionId(sid);
                return;
            }
        }

        //  setViewIndex(data.question_index);   // enter history mode
        setViewIndex(null);   // Always resume in LIVE mode
        setCurrentQuestion(data.question);   // last answered question
        setCurrentAudioPath(data.audio_path || "");
        setExpertise(data.answer || "");     // last answer
        setCurrentStage(data.stage);
        setSessionId(data.session_id);

        // play audio
        // if (!isExpertiseMuted) {
        //     console.log("audio called from resume")
        //     stopAllAudio(); 
        //     fetchExpertiseSpeech(data.question);
        // }
    };

    const formatAIResponse = (text: string) => {
        if (!text) return "";

        let formatted = text;

        // remove markdown symbols
        formatted = formatted.replace(/\*{2,}/g, "");
        formatted = formatted.replace(/#{1,}/g, "");

        // convert bullet points (* or -)
        formatted = formatted.replace(/^\* (.+)$/gm, "• $1");
        formatted = formatted.replace(/^- (.+)$/gm, "• $1");

        // convert bullet lines into <ul>
        formatted = formatted.replace(
            /(?:^|\n)(• .*(?:\n• .*)*)/g,
            (match) => {
                const items = match
                    .trim()
                    .split("\n")
                    .map((line) => `<li>${line.replace(/^• /, "")}</li>`)
                    .join("");
                return `<ul>${items}</ul>`;
            }
        );

        // headings (simple)
        formatted = formatted.replace(/^(.+):$/gm, "<h3>$1</h3>");

        // paragraphs
        formatted = formatted.replace(
            /^(?!<h3>|<ul>|<li>|<\/ul>)(.+)$/gm,
            "<p>$1</p>"
        );

        // cleanup empty
        formatted = formatted.replace(/<p>\s*<\/p>/g, "");

        return formatted;
    };

    const stripHtml = (html: string) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
    };

    const getChatBotResponse = async (query: string) => {
        if (!query.trim()) return;

        // add user message
        setChatMessages((prev) => [...prev, { role: "user", text: query }]);

        setQuestionText("");
        setIsChatLoading(true);

        try {
            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

            const res = await axios.post(`${apiUrl}/api/prompts/chat_answer`, {
                courseid: "6a149b25195a2644a8352674",
                query,
                chapter: ""
            });

            let answer = res?.data?.response || "No response";

            // cleanup formatting (same as view-course)
            answer = answer.replace(/\*{2,}/g, "");
            answer = answer.replace(/#{1,}/g, "");
            answer = answer.replace(/^\* (.+)$/gm, "• $1");

            const formatted = formatAIResponse(answer);

            setChatMessages((prev) => [
                ...prev,
                {
                    role: "bot",
                    text: formatted,
                },
            ]);

            // store clean text for TTS
            const cleanText = stripHtml(answer);
            setLastBotText(cleanText);

        } catch (err) {
            console.error("Chat error", err);
        } finally {
            setIsChatLoading(false);
        }
    };

    /* useEffect(() => {
        if (!lastBotText) return;

        // Prevent duplicate autoplay
        if (prevTextRef.current === lastBotText) return;

        // Mark as played
        prevTextRef.current = lastBotText;

        // STOP EVERYTHING FIRST
        stopAllAudio();

        // Small delay ensures clean reset (important)
        const timer = setTimeout(() => {
            dispatch(
                speakText({
                    text: lastBotText,
                    voice: "default.wav",
                    id: "global-tts",
                })
            );
            setCurrentAudioType("tts");
        }, 150);

        return () => clearTimeout(timer);
    }, [lastBotText, dispatch]); */
    useEffect(() => {
        if (!lastBotText) return;

        if (prevTextRef.current === lastBotText) return;

        prevTextRef.current = lastBotText;

        stopAllAudio();
        setCurrentAudioType(null);
        playText(lastBotText);
    }, [lastBotText]);

    useEffect(() => {
        (window as any).isMutedGlobal = isMuted;

        audioManager.applyMute(isMuted);

        if (audioRef.current) {
            audioRef.current.muted = isMuted;
        }
    }, [isMuted]);

    const pollTaskStatus = async (taskId: string) => {
        const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

        while (true) {
            try {
            const res = await getTaskStatus(taskId).unwrap();

            console.log("Polling status:", res);

            if (res.state === "done") {
                return res.result;
            }

            if (res.state === "error" || res.state === "failed") {
                throw new Error("Task failed");
            }

            // wait 5 seconds
            await new Promise((resolve) => setTimeout(resolve, 5000));

            } catch (err) {
            console.error("Polling error:", err);
            throw err;
            }
        }
    };

    const doStartInterview = async () => {
        if (isStarting) return;

        setIsStarting(true);

        try {
            // Step 1: trigger background job
            const triggerRes = await startInterviewTrigger({
            user_id: user_email,
            language: "English",
            combined_text: transcribedText,
            }).unwrap();

            console.log("Task triggered:", triggerRes);

            const taskId = triggerRes.task_id;

            // Step 2: poll until done
            const result = await pollTaskStatus(taskId);

            console.log("Final result:", result);

            // Step 3: update UI
            setSessionId(result.session_id);
            setCurrentQuestion(result.question);
            setCurrentAudioPath(result.audio_path || "");
            setCurrentStage(result.stage);
            setExpertise("");

            persistSession(
            result.session_id,
            result.question,
            result.stage,
            [],
            result.audio_path || ""
            );

        } catch (err: any) {
            console.error("Start interview failed:", err);
            toast.error("Failed to start interview");
        } finally {
            setIsStarting(false);
        }
    };



    // const doStartInterview = async () => {
    //   if (isStarting) return; // prevent duplicate calls

    //   setIsStarting(true);

    //   try {

    //     console.log("transcribedText", transcribedText);
    //     const res = await retryAsync(
    //       () =>
    //         startInterview({
    //           user_id: user_email,
    //           language: "English",
    //           combined_text: transcribedText,
    //         }).unwrap(),

    //       3,      // retries
    //       2000,   // delay

    //       // ✅ VALIDATION: ensure required fields exist
    //       (response) => {
    //         return (
    //           response &&
    //           typeof response.session_id === "string" &&
    //           response.session_id.length > 0 &&
    //           typeof response.question === "string" &&
    //           response.question.length > 0
    //         );
    //       }
    //     );

    //     // ✅ only runs when valid response received
    //     setSessionId(res.session_id);
    //     setCurrentQuestion(res.question);
    //     setCurrentAudioPath(res.audio_path || "");
    //     setCurrentStage(res.stage);
    //     setExpertise("");

    //     persistSession(res.session_id, res.question, res.stage, []);
    //   } catch (err: any) {
    //     console.error("Failed to start interview", err);

    //     toast.error(
    //       err?.data?.message ||
    //         "Failed to start interview after multiple attempts."
    //     );
    //   } finally {
    //     setIsStarting(false);
    //   }
    // };

    // ─── PREVIOUS button ──────────────────────────────────────────────────────
    /* const handleDTPrevious = () => {
        if (viewIndex === null) {
            if (sessionHistory.length === 0) return;
            const idx = sessionHistory.length - 1;
            setViewIndex(idx);
            setCurrentQuestion(sessionHistory[idx].question);
            setExpertise(sessionHistory[idx].answer);
        } else if (viewIndex > 0) {
            const idx = viewIndex - 1;
            setViewIndex(idx);
            setCurrentQuestion(sessionHistory[idx].question);
            setExpertise(sessionHistory[idx].answer);
        }
    }; */

    const updateCombinedText = async (courseId: string) => {
      const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";

      try {
        const res = await axios.post(
          `${apiUrl}/api/prompts/update_combined_text?course_id=${courseId}`,
          {},
          {
            headers: { accept: "application/json" },
          }
        );

        return res.data;
      } catch (err) {
        console.error("update_combined_text failed", err);
        throw err;
      }
    };

    const handleDTPrevious = () => {
        stopAllAudio();
        setIntroDone(true);
        if (sessionHistory.length === 0) return;

        let newIndex;

        if (viewIndex === null) {
            // Detect "complete & visually parked on the last question" from
            // history length itself, NOT from interviewDone — that flag depends
            // on the backend reporting status === "interview_completed" on
            // resume, which isn't always guaranteed. If we're parked, the UI
            // is already showing "6 of 6", so Previous must jump to N-2.
            const isParked = sessionHistory.length >= TOTAL_QUESTIONS;
            
            newIndex = isParked
                ? sessionHistory.length - 2
                : sessionHistory.length - 1;

            if (newIndex < 0) return;
        } else if (viewIndex > 0) {
            newIndex = viewIndex - 1;
        } else {
            return; // already at first
        }

        setViewIndex(newIndex);

        const item = sessionHistory[newIndex];

        setCurrentQuestion(item.question);
        setExpertise(item.answer);
        setCurrentAudioPath(item.audio_path || "");

        // play audio
        if (!isExpertiseMuted) {
            stopAllAudio(); 
            //fetchExpertiseSpeech(item.question);
        }
    };

    // ─── NEXT / SUBMIT button ─────────────────────────────────────────────────
    const handleDTNext = async () => {
        stopAllAudio();
        setIntroDone(true);
        // If browsing history, move forward without submitting

        //if (questionIndex >= 5) newIndex =  4;
        console.log(sessionHistory);
        console.log(viewIndex + " < " + (sessionHistory.length - 1));
        if (viewIndex !== null) {
            if (viewIndex === sessionHistory.length - 1) {
                // If we're parked on the last answered question of a completed
                // interview, there is no further question. Treat Next/Submit the
                // same as the bottom Continue button: advance to the next page.
                if (sessionHistory.length >= TOTAL_QUESTIONS) {
                    stopAllAudio();
                    if (planDetails?.payment_status === 'pending') {
                        handleCheckout(planDetails?._id);
                    } else {
                        navigate('/codegenie/new-course-4', {
                            state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' },
                        });
                    }
                    return;
                }

                // Mid-interview: return from history review to the live (unanswered) question.
                setViewIndex(null);
                setCurrentQuestion(localStorage.getItem('dt_current_question') || currentQuestion);
                setExpertise(localStorage.getItem('expertise') || '');

                if (!isExpertiseMuted) {
                    stopAllAudio();
                    //fetchExpertiseSpeech(localStorage.getItem('dt_current_question') || currentQuestion);
                }

                return;
            }
            if (viewIndex < sessionHistory.length - 1) {
                console.log("handleDTNext if--");
                const idx = viewIndex + 1;
                setViewIndex(idx);
                setCurrentQuestion(sessionHistory[idx].question);
                setExpertise(sessionHistory[idx].answer);
                setCurrentAudioPath(sessionHistory[idx].audio_path || "");
                
                // Only play if question speaker is active (not muted)
                if (!isExpertiseMuted) {
                    stopAllAudio(); 
                    //fetchExpertiseSpeech(sessionHistory[idx].question);
                }
            } else {
                // Back to live question
                console.log("back to live questions");
                setViewIndex(null);
                setCurrentQuestion(localStorage.getItem('dt_current_question') || currentQuestion);
                setExpertise(localStorage.getItem('expertise') || '');

                if (!isExpertiseMuted) {
                    stopAllAudio(); 
                    //fetchExpertiseSpeech(localStorage.getItem('dt_current_question') || currentQuestion);
                }
            }
            return;
        }

        // Live question: validate
        if (!expertise || expertise.trim().length < 10) {
            toast.error('Please provide at least 10 characters before continuing.');
            return;
        }

        localStorage.setItem('expertise', expertise);

        setIsAnswering(true);
        try {
            // 1. Submit answer → get next question
            const answerRes = await answerQuestion({
                session_id: sessionId,
                question: currentQuestion,
                answer: expertise,
            }).unwrap();

            // 2. Extract authority in background
            //extractAuthority({ answer: expertise }).catch(() => { });

            // 3. Build updated history
            const newEntry: SessionEntry = {
                question: currentQuestion,
                answer: expertise,
                stage: currentStage,
                audio_path: currentAudioPath,
            };
            const existingIndex = viewIndex !== null
                ? viewIndex
                : sessionHistory.length;

            let newHistory = [...sessionHistory];

            //  Prevent duplicate of last question
            const lastEntry = newHistory[newHistory.length - 1];

            if (
                lastEntry &&
                lastEntry.question === newEntry.question &&
                lastEntry.answer === newEntry.answer
            ) {
                console.log("Skipping duplicate entry");
            } else if (existingIndex < newHistory.length) {
                newHistory[existingIndex] = newEntry;
            } else {
                newHistory.push(newEntry); 
            }
            if (setSessionHistory.length <= TOTAL_QUESTIONS)
                setSessionHistory(newHistory);
            persistSession(sessionId, answerRes.question, answerRes.stage, newHistory, answerRes.audio_path || "");
            // Interview complete?
            if (answerRes.status === "interview_completed") {
                // await generateBlueprint({ session_id: sessionId }).unwrap();
                setInterviewDone(true);
                persistSession(sessionId, '', answerRes.stage, newHistory, answerRes.audio_path || "");

                // Build combined expertise text
                const allAnswers = newHistory.map((h) => h.answer).join('\n\n');

                // Fetch course details and merge expertise
                let combinedExpertise = allAnswers;
                try {
                    const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
                    const storedCourseId = localStorage.getItem("course_id") || "";
                    if (storedCourseId) {
                        const { data } = await axios.post<GetCourseDetailsResponse>(
                            `${apiUrl}/api/prompts/get_course_details`,
                            { course_id: storedCourseId }
                        );
                        if (data?.result?.expertise) {
                            combinedExpertise = `${data.result.expertise}\n\n${allAnswers}`;
                        }
                    }
                } catch (error) {
                    console.error("Failed to fetch course details for merging", error);
                    // falls back to allAnswers only
                }

                await handleSubmit(combinedExpertise);  // send merged text

                stopAllAudio();
                /* navigate('/codegenie/new-course-2-1', {
                    state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' },
                }); */

                const courseId = localStorage.getItem("course_id");

                if (courseId) {
                  try {
                    setIsLoadingCourse(true); // optional loader

                    await retryAsync(
                      () => updateCombinedText(courseId),
                      2,
                      1500
                    );

                    console.log("combined text updated");

                  } catch (err) {
                    console.error("Update combined text failed", err);
                    // optional: continue anyway OR block navigation
                  } finally {
                    setIsLoadingCourse(false);
                  }
                }

                navigate('/codegenie/new-course-4', {
                    state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' },
                });
                //localStorage.setItem("activeItem", "authority");
                //navigate("/codegenie/generated-blogs");
                return;
            }

            // 5. Show next question
            setCurrentQuestion(answerRes.question);
            setCurrentAudioPath(answerRes.audio_path || "");
            setCurrentStage(answerRes.stage);
            setExpertise('');
            localStorage.setItem('expertise', '');
            persistSession(sessionId, answerRes.question, answerRes.stage, newHistory);
            // Auto-play next question only if question speaker is not muted
            if (!isExpertiseMuted) {
                stopAllAudio(); 
                //fetchExpertiseSpeech(answerRes.question);
            }
        } catch (err) {
            console.error('Failed to submit answer', err);
            toast.error('Something went wrong. Please try again.');
        } finally {
            setIsAnswering(false);
        }
    };

    // ─── Derived UI helpers ───────────────────────────────────────────────────

    const isViewingHistory = viewIndex !== null;


    const isParkedAtEnd =
        isViewingHistory &&
        viewIndex === sessionHistory.length - 1 &&
        sessionHistory.length >= TOTAL_QUESTIONS;

    // Clamp to TOTAL_QUESTIONS - 1 so we don't display "7 of 6" once the
    // interview is complete and the user returns to view the last question.
    let questionIndex = viewIndex !== null
        ? viewIndex
        : Math.min(sessionHistory.length, TOTAL_QUESTIONS - 1);

    const canGoPrevious = isViewingHistory ? viewIndex! > 0 : sessionHistory.length > 0;
    const isBusy = isStarting || isAnswering || isScrapcheckloading;


    // ─────────────────────────────────────────────────────────────────────────────

    const startRecording = async (target: "expertise" | "question") => {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            console.error("mediaDevices not supported");
            return;
        }

        const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

        const mediaRecorder = new MediaRecorder(stream, {
            mimeType: "audio/webm",
        });

        audioChunksRef.current = [];

        mediaRecorder.ondataavailable = (event) => {
            if (event.data.size > 0) {
                audioChunksRef.current.push(event.data);
            }
        };

        mediaRecorder.onstop = () => sendAudioToBackend(target);

        mediaRecorder.start();
        mediaRecorderRef.current = mediaRecorder;

        if (target === "expertise") {
            setIsRecordingExpertise(true);
        } else {
            setIsRecordingQuestion(true);
        }
    };

    const stopRecording = () => {
        mediaRecorderRef.current?.stop();

        setIsRecordingExpertise(false);
        setIsRecordingQuestion(false);
    };

    const sendAudioToBackend = async (target: "expertise" | "question") => {
        const audioBlob = new Blob(audioChunksRef.current, {
            type: "audio/webm",
        });

        await saveVoiceSample(audioBlob);

        const formData = new FormData();
        formData.append("audio", audioBlob, "speech.webm");

        try {
            const res = await fetch(`${process.env.REACT_APP_SPEECH_TO_TEXT_SERVICE}/speech_to_text`, {
                method: "POST",
                body: formData,
            });

            const data = await res.json();

            if (target === "expertise") {
                setExpertise((prev) => `${prev} ${data.text}`.trim());
            } else {
                setQuestionText((prev) => `${prev} ${data.text}`.trim());
            }

        } catch (err) {
            console.error("Speech upload failed", err);
        }
    };

    useEffect(() => {
        if (!("webkitSpeechRecognition" in window)) {
            console.warn("Speech recognition not supported");
            return;
        }

        const recognition = new (window as any).webkitSpeechRecognition();
        recognition.continuous = true;
        recognition.interimResults = true;
        recognition.lang = "en-US";

        /* recognition.onresult = (event: any) => {
            const transcript = event.results[0][0].transcript;
            setExpertise((prev) => `${prev} ${transcript}`.trim());
        }; */
        recognition.onresult = (event: any) => {
            let finalTranscript = "";

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const result = event.results[i];

                // Only take FINAL result
                if (result.isFinal) {
                    finalTranscript += result[0].transcript;
                }
            }

            if (finalTranscript) {
                setQuestionText((prev) => (prev + " " + finalTranscript).trim());
            }
        };

        recognition.onend = () => {
            setIsListening(false);
        };

        recognition.onerror = () => {
            setIsListening(false);
        };

        recognitionRef.current = recognition;
    }, []);


    useEffect(() => {
        const campaignRes = async () => {
            try {
                const response = await campaignListMutation({ email: user_email || getCookie('user_email') || "" });
                if ('data' in response) {
                    setCampaignDatas(response.data);
                    console.log('campaign list response=>', response.data)
                } else {
                    console.error('Error fetching campaign List:', response.error);
                }
            } catch (error) {
                console.log('Error fetching campaign List:', error);
            }
        }
        campaignRes();
    }, [user_email])

    useEffect(() => {
        localStorage.removeItem('publishingCampId');
    }, []);

    const handleEditClick = () => {
        textareaRef.current?.focus();
    };

    const handleMicClick = async () => {
        if (!recognitionRef.current) return;

        if (isListening) {
            recognitionRef.current.stop();
            setIsListening(false);
            return;
        }

        try {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                console.error("mediaDevices not supported");
                return;
            }

            await navigator.mediaDevices.getUserMedia({ audio: true });

            recognitionRef.current.start();
            setIsListening(true);
        } catch (err) {
            console.error("Mic access error", err);
        }
    };

    const youtubeMatch = videoTag?.match(
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|embed|watch)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
    );

    useEffect(() => {
        let intervalId: any;
        if (isloadingGetPage && loaderProgress < 100) {
            intervalId = setInterval(() => {
                setLoaderProgress((prevProgress: any) => {
                    const newProgress = prevProgress + 2;
                    return newProgress >= 98 ? 98 : newProgress;
                });
            }, intervaltime);
        }
        return () => clearInterval(intervalId);
    }, [isloadingGetPage, loaderProgress]);

    interface TaskStatusResponse {
        state: "pending" | "done" | "error";
        result?: any;
        message?: string;
    }

    interface CreateCourseResponse {
        status: string;
        message: string;
        course_id: string;
    }

    const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

    const waitForTaskResult = async (taskId: string, apiUrl: string): Promise<any> => {
        const statusUrl = `${apiUrl}/api/prompts/task_status?task_id=${taskId}`;
        while (true) {
            const { data } = await axios.get<TaskStatusResponse>(statusUrl);
            if (data.state === "done") {
                return data.result;
            } else if (data.state === "error") {
                throw new Error(data.message || "Task failed");
            }
            await sleep(2000);
        }
    };

    const handleSubmit = async (expertise: string) => {
        setIsScrapcheckloading(true);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const course_id = localStorage.getItem("course_id") || "";
            const user_email = localStorage.getItem("user_email") || "";
            const { data } = await axios.post<CreateCourseResponse>(`${apiUrl}/api/prompts/create_course`, {user_email, expertise, course_id });
            const courseId = data.course_id;

            if (courseId) {
                setIsLoadingGetPage(false);
                toast.success(data.message);
                localStorage.setItem("course_id", courseId);
            } else {
                toast.error("Something went wrong, please try again");
                return false;
            }
        } catch (error) {
            console.log(error);
        } finally {
            setIsScrapcheckloading(false);
        }
    }

    useEffect(() => {
        console.log(campaignId);
    }, [campaignId]);

    const handleCreateCourseStep2 = async () => {
        if (!expertise || expertise.trim().length < 100) {
            toast.error("Please provide at least 100 characters of expertise.");
            return;
        }
        else {
            const data = await handleSubmit(expertise);
        }
        stopAllAudio();

        const courseId = localStorage.getItem("course_id");

        if (courseId) {
          try {
            setIsLoadingCourse(true); // optional loader

            await retryAsync(
              () => updateCombinedText(courseId),
              2,
              1500
            );

            console.log("combined text updated");

          } catch (err) {
            console.error("Update combined text failed", err);
            // optional: continue anyway OR block navigation
          } finally {
            setIsLoadingCourse(false);
          }
        }
        // navigate('/codegenie/new-course-2-1', { state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' } });
        navigate('/codegenie/new-course-4', { state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' } });

    }

    /* const handleCreateCourseStepPrevious = async () => {
        navigate('/codegenie/new-course')
    } */
    const handleCreateCourseStepPrevious = async () => {
        // resetUploadState();
        stopAllAudio();
        //Save and then move to next screen
        navigate('/codegenie/new-course-2', { state: { FromSignUp: FromSignUp === 'true' ? FromSignUp : '' } });

    }

    const handleCreateCampaignClick = async () => {
        console.log('fromedit=>', FromEdit);
        console.log('campId=>', campIdFrEdit);
        if (FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true') {
            autoPublishCheck(campIdFrEdit);
            handleUpdateSetting(campIdFrEdit);
            localStorage.removeItem('ChangepayMode');
            localStorage.removeItem('IdChangingMode');
        }
        else {
            if (
                (urlPrefix === 'text' && userBusinessText === '') ||
                (urlPrefix === 'https://' && sourceUrl === '') ||
                (urlPrefix === 'youtubeid' && sourceYoutubeUrl === '') ||
                (urlPrefix === 'upload' && !uploadedvideopath)
            ) {
                toast.error('Please fill any one of the source type!');
            } else if ((sourceUrl || userBusinessText) && blogcount > planDetails?.blog_count_balance) {
                setUpgradeModal(true);
            } else if ((sourceYoutubeUrl || uploadedvideopath) && blogcount > planDetails?.podcast_count_balance) {
                setUpgradeModal(true);
            }
            else {
                try {
                    var tmpurl = urlPrefix === 'youtubeid' ? (document.getElementById('sourceyoutubeurl') as HTMLInputElement)?.value : '';
                    if (tmpurl.indexOf("http") < 0) tmpurl = urlPrefix === 'youtubeid' ? "https://" + tmpurl : '';
                    const finalurl = tmpurl;
                    const youtubeMatch = finalurl?.match(
                        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/|live\/|playlist\?list=)|youtu\.be\/)([a-zA-Z0-9_-]+)/
                    );
                    const videoid = youtubeMatch ? youtubeMatch[1] : '';
                } catch (error) {
                    setIsLoadingGetPage(false);
                    console.log('Error creating campaign:', error);
                }
            }
        }
    }

    useEffect(() => {
        if (FromEdit === 'startEditing') {
            getVerifyingScript(campIdFrEdit);
            handleVerifyCheckClick(campIdFrEdit);
            cnameRec(campIdFrEdit);
        }
    }, []);

    const cnameRec = async (campIdFrEdit: string) => {
        try {
            const response = await getCnameEntriesMutation({ email: user_email || getCookie('user_email') || "", campaignid: campIdFrEdit || '' });
            if ('data' in response) {
                console.log('cnameentries=>', response.data.cnamerecords);
                setCnameDomainName(response.data);
                setCnameRecords(response.data.cnamerecords);
            }
        } catch (error) {
            console.log('Error fetching dns record:', error);
        }
    }

    const fetchPlanDatas = async () => {
        try {
            const response = await getuserPlanDetails({ email: user_email || getCookie('user_email') || '', campaignid: '' });
            if ('data' in response) {
                setPlanDetails(response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchPlanDatas();
    }, []);

    const fetchCampDatas = async () => {
        try {
            const response = await getuserCampDetails({ campaignid: campIdFrEdit || '' });
            if ('data' in response) {
                setCampDetails(response.data.data);
                console.log('camp details***=>', response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        if (FromEdit === 'startEditing') {
            fetchCampDatas();
        }
    }, []);

    const autoPublishCheck = async (id: string) => {
        setIsUpdateLoader(true);
        try {
            const validVideoTag = videoTag?.trim() || campDetails?.videotag?.trim() || '';
            const response = await updateAutoPublishCheckMutation({ campaign_id: id, autopublish: autoPublish ? 1 : 0, threeblogperday: limitPublish ? 1 : 0, addtags: addtags ? 1 : 0, capturleads: capturleads ? 1 : 0, twitterurl: planDetails?.twitterurl || twitterUrl || '', fburl: planDetails?.fburl || fbUrl || '', pintresturl: planDetails?.pintresturl || pintrestUrl || '', linkedinurl: planDetails?.linkedinurl || linkedinUrl || '', newsletter: newsletter ? 1 : 0, twitternbutton: twitternbutton ? 1 : 0, fbbutton: fbbutton ? 1 : 0, pintrestbutton: 0, linkedinbutton: linkedinbutton ? 1 : 0, video: video ? 1 : 0, owndomain: useOwnDomain ? 1 : 0, cta_lable: ctaLabel ? encodeURIComponent(ctaLabel) : planDetails?.cta_lable ? encodeURIComponent(planDetails?.cta_lable) : 'Learn More', cta_link: ctaLink ? encodeURIComponent(ctaLink) : campDetails?.cta_link ? encodeURIComponent(campDetails?.cta_link) : sourceUrl, videotag: encodeURIComponent(validVideoTag), iframe: 1, publish_to_ocesha: publishToOcesha ? 1 : 0, publish_to_code_genie: publishToCodegenie ? 1 : 0, competetor_search: competitorSearch ? 1 : 0 });
            console.log(response);
            if (FromEdit === 'startEditing') {
                if ('data' in response) {
                    console.log(response.data.msg);
                    if (FromEdit === 'startEditing') {
                        toast.success('Blog settings updated successfully!');
                    } else {
                        toast.success(response.data.msg);
                    }
                }
            }
        } catch (error) {
            console.log('Error:', error);
        } finally {
            setIsUpdateLoader(false);
        }
    }

    const fetchData = async () => {
        try {
            const response = await getUserDetailsMutation({ email: user_email || getCookie('user_email') || '', filter: '', start_date: '', end_date: '' });
            if ('data' in response) {
                console.log(response.data.data);
                setUserDetails(response.data.data);
                console.log('userDet =>', response.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        localStorage.removeItem('FromSignUp');
    }, []);

    const handleCheckout = async (campaignId: string) => {
        let referral_param = localStorage.getItem("referral_param");
        localStorage.removeItem("referral_param");

        try {
            const response = await createCheckoutSession({ "emailid": user_email || getCookie('user_email') || "", "username": userDetails.name, "subscription_level": selectedSubscriptionLevel, "referral_param": referral_param || "", "couponcode": couponCode ?? "", "mode": '', campaignid: campaignId || '', "from_page": 'campaign', return_domain: '' });

            if (response.data.message == "Checkout url created") {
                const checkoutUrl = response.data.checkout_url;
                window.location.href = checkoutUrl;
            }
            else if (response.data.error) {
                const errorMessage = response.data.error;
                if (errorMessage.includes('This promotion code cannot be redeemed because the associated customer has prior transactions.')) {
                    toast.error('Coupon code already applied');
                } else if (errorMessage.includes('This coupon cannot be redeemed because it does not apply to anything in this order.')) {
                    toast.error('Invalid Coupon code');
                } else {
                    toast.error('Invalid Coupon code');
                }
            }
        }
        catch (e) {
            alert(e);
            console.log(e);
        }
    }

    const data = [
        { heading: 'QUANTITY', value: '1' },
        { heading: 'PLAN TYPE', value: period === 'monthly' ? 'Monthly' : 'Yearly' },
        { heading: 'PLAN NAME', value: planDetails ? (planDetails.subscription_level === 'level_0' || planDetails.subscription_level === 'level_0y' ? 'Starter' : planDetails.subscription_level === 'level_1' || planDetails.subscription_level === 'level_4' ? 'Basic' : planDetails.subscription_level === 'level_2' || planDetails.subscription_level === 'level_5' ? 'Pro' : planDetails.subscription_level === 'level_3' || planDetails.subscription_level === 'level_6' ? 'Traffic Hacker' : '') : selectedSubscriptionLevel ? (selectedSubscriptionLevel === 'level_0' || selectedSubscriptionLevel === 'level_0y' ? 'Starter' : selectedSubscriptionLevel === 'level_1' || selectedSubscriptionLevel === 'level_4' ? 'Basic' : selectedSubscriptionLevel === 'level_2' || selectedSubscriptionLevel === 'level_5' ? 'Pro' : selectedSubscriptionLevel === 'level_3' || selectedSubscriptionLevel === 'level_6' ? 'Traffic Hacker' : '') : '' },
        { heading: 'TOTAL', value: planDetails ? (planDetails?.subscription_level === 'level_0' ? '$49/mo.' : planDetails?.subscription_level === 'level_1' ? '$99/mo.' : planDetails?.subscription_level === 'level_2' ? '$199/mo.' : planDetails?.subscription_level === 'level_3' ? '$299/mo.' : planDetails?.subscription_level === 'level_0y' ? '$' + (48.8 * 12).toFixed(1) + '/yr.' : planDetails?.subscription_level === 'level_4' ? '$' + (82.5 * 12).toFixed(1) + '/yr.' : planDetails?.subscription_level === 'level_5' ? '$' + (165.8 * 12).toFixed(1) + '/yr.' : planDetails?.subscription_level === 'level_6' ? '$' + (249.16 * 12).toFixed(1) + '/yr.' : '') : paymentOptYearlyCal },
    ];

    const handledropdownChange = (event: any) => {
        setSelectedSection(event.target.value);
    }

    const handleSourceUrlChange = (event: any) => {
        let urlVal = event.target.value;
        if (urlVal.startsWith('https://')) {
            urlVal = urlVal.replace('https://', '');
        }
        const element = document.getElementById("authurl") as HTMLInputElement;
        setSourceUrl(urlVal);
        localStorage.setItem('sourceurl', urlVal);
        if (element && !socialUrl) {
            element.value = urlVal;
            setSocialUrl(urlVal);
        }
    }

    const handleblogscountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setBlogCount(value);
        } else {
            toast.error('Please enter numeric value!');
        }
    }

    const handleSourceYoutubeUrlChange = (event: any) => {
        let urlVal = event.target.value;
        if (urlVal.startsWith('https://')) {
            urlVal = urlVal.replace('https://', '');
        }
        const element = document.getElementById("authurl") as HTMLInputElement;
        setSourceYoutubeUrl(urlVal);
        if (element && !socialUrl) {
            element.value = urlVal;
            setSocialUrl(urlVal);
        }
    }

    const handleSourceTextChange = (event: any) => {
        let textVal = event.target.value;
        setSourceText(textVal);
        localStorage.setItem('sourcetext', textVal);
    }

    const handlePodcastUrlChange = (event: any) => {
        let podcastVal = event.target.value;
        setPodcastOrYoutubeUrl(podcastVal);
        localStorage.setItem('podcastUrl', podcastVal);
    }

    useEffect(() => {
        if (sourceYoutubeUrl) {
            setVideoTag(sourceYoutubeUrl);
        }
    }, [sourceYoutubeUrl]);

    const handlevideotag = (event: any) => {
        let videotagg = event.target.value.trim();;
        setVideoTag(videotagg);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                videotag: videotagg
            })
        }
        localStorage.setItem('videoTag', videotagg);
    }

    const handletwitterUrlChange = (event: any) => {
        let urlVal = event.target.value;
        settwitterUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                twitterurl: urlVal
            });
        }
        localStorage.setItem('twitterurl', urlVal);
    }

    const handlefbUrlChange = (event: any) => {
        let urlVal = event.target.value;
        setfbUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                fburl: urlVal
            });
        }
        localStorage.setItem('fburl', urlVal);
    }

    const handlepintrestUrlChange = (event: any) => {
        let urlVal = event.target.value;
        setPintrestUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                pintresturl: urlVal
            });
        }
        localStorage.setItem('pintresturl', urlVal);
    }

    const handleCtaLabelChange = (event: any) => {
        let label = event.target.value;
        setCtaLabel(label);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                cta_lable: label
            });
        }
    }

    const handleCtaLinkChange = (event: any) => {
        let link = event.target.value;
        setCtaLink(link);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                cta_link: link
            });
        }
    }

    const handlelinkedinUrlChange = (event: any) => {
        let urlVal = event.target.value;
        setLinkedinUrl(urlVal);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                linkedinurl: urlVal
            });
        }
        localStorage.setItem('linkedinurl', urlVal);
    }

    const handlepaymentOptions = (value: any, subscription_level: any) => {
        setPaymentOption(value);
        setSelectedSubscriptionLevel(subscription_level);
        setPaymentOptYearlyCal(value === '$48.8/mo.' && period === 'yearly' ? '$' + (48.8 * 12).toFixed(1) + '/yr.' : value === '$82.5/mo.' ? '$' + (82.5 * 12).toFixed(1) + '/yr.' : value === '$165.8/mo.' ? '$' + (165.8 * 12).toFixed(1) + '/yr.' : value === '$249.16/mo.' ? '$' + (249.16 * 12).toFixed(1) + '/yr.' : value)
        localStorage.setItem('paymentOption', value);
        localStorage.setItem('PaymentSubscription', subscription_level);

        if (subscription_level == 'level_0' || subscription_level == 'level_0y' || subscription_level == 'level_1'
            || subscription_level == 'level_2' || subscription_level == 'level_4' || subscription_level == 'level_5') {
            setExpanded3(false);
            setExpanded6(false);
            setExpanded7(false);
            setExpanded8(false);
            setExpanded9(false);
            setSocialMediaUrlPublish(false)
            setCapturLeads(false);
            setNewsLetter(false);
            setTwitternButton(false);
            setFbButton(false);
            setPintrestButton(false);
            setLinkedinButton(false);
            settwitterUrl('');
            setfbUrl('');
            setPintrestUrl('');
            setLinkedinUrl('');
        }
        else {
            setCapturLeads(true);
            setNewsLetter(true);
            setTwitternButton(true);
            setFbButton(true);
            setPintrestButton(true);
            setLinkedinButton(true);
        }
    }

    const paymentSubscription = localStorage.getItem('PaymentSubscription') || '';

    const handleAutoPublishChange = (event: any) => {
        const isChecked = event.target.checked;
        setAutopublish(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                autopublish: isChecked
            });
        }
        localStorage.setItem('autoPublish', isChecked.toString());
    };

    const handlePublishToOceshaChange = (event: any) => {
        const isChecked = event.target.checked;
        setPublishToOcesha(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                publish_to_ocesha: isChecked
            });
        }
        localStorage.setItem('publish_to_ocesha', isChecked.toString());
    };

    const handleCompetitorSearchChange = (event: any) => {
        const isChecked = event.target.checked;
        setCompetitorSearch(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                competetor_search: isChecked
            });
        }
        localStorage.setItem('competitor_search', isChecked.toString());
    };

    const handlePublishToCodegenieChange = (event: any) => {
        const isChecked = event.target.checked;
        setPublishToCodegenie(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                publish_to_code_genie: isChecked
            });
        }
        localStorage.setItem('publish_to_code_genie', isChecked.toString());
    };

    const handlelimitPublishChange = (event: any) => {
        const isChecked = event.target.checked;
        setLimitPublish(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                threeblogperday: isChecked
            });
        }
        localStorage.setItem('limitPublish', isChecked.toString());
    };

    const handlesocialMediaUrlPublishChange = (event: any) => {
        const isChecked = event.target.checked;
        setSocialMediaUrlPublish(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                socialMediaUrlPublish: isChecked
            });
        }
        localStorage.setItem('smUrlpublish', isChecked.toString());
    };

    const handleaddtagsChange = (event: any) => {
        const isChecked = event.target.checked;
        setAddTags(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                addtags: isChecked
            });
        }
        localStorage.setItem('addTags', isChecked.toString());
    };

    const handletocChange = (event: any) => {
        const isChecked = event.target.checked;
        setToc(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                toc: isChecked
            });
        }
        localStorage.setItem('toc', isChecked.toString());
    };

    const handleexternalLinksChange = (event: any) => {
        const isChecked = event.target.checked;
        setExternalLinks(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                external_links: isChecked
            });
        }
        localStorage.setItem('externalLinks', isChecked.toString());
    };

    const handlecapturleadsChange = (event: any) => {
        const isChecked = event.target.checked;
        setCapturLeads(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                capturleads: isChecked
            });
        }
        localStorage.setItem('captureLeads', isChecked.toString());
    };

    const handlenewsletterChange = (event: any) => {
        const isChecked = event.target.checked;
        setNewsLetter(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                newsletter: isChecked
            });
        }
        localStorage.setItem('newsLetter', isChecked.toString());
    };

    const handletwitterBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setTwitternButton(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                twitternbutton: isChecked
            });
        }
        localStorage.setItem('twitterBtn', isChecked.toString());
    };

    const handlefbBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setFbButton(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                fbbutton: isChecked
            });
        }
        localStorage.setItem('fbBtn', isChecked.toString());
    };

    const handlepintrestBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setPintrestButton(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                pintrestbutton: isChecked
            });
        }
        localStorage.setItem('pintrestBtn', isChecked.toString());
    };

    const handlelinkedinBtnChange = (event: any) => {
        const isChecked = event.target.checked;
        setLinkedinButton(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                linkedinbutton: isChecked
            });
        }
        localStorage.setItem('linkedinBtn', isChecked.toString());
    };

    const handlevideoChange = (event: any) => {
        const isChecked = event.target.checked;
        setVideo(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                video: isChecked
            });
        }
        localStorage.setItem('video', isChecked.toString());
    };

    const handleOwnDomainChange = (event: any) => {
        const isChecked = event.target.checked;
        setUseOwnDomain(isChecked);
        if (planDetails) {
            setPlanDetails({
                ...planDetails,
                owndomain: isChecked
            });
        }
        localStorage.setItem('owndomain', isChecked.toString());
    };

    const handleAuthorUseDefaultChange = (event: any) => {
        const isChecked = event.target.checked;
        setUseAsDefault(isChecked);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                use_as_default: isChecked
            });
        } else if (userDetails) {
            setUserDetails({
                ...userDetails,
                blog_default: isChecked
            });
        }
        localStorage.setItem('authorDefaultCheck', isChecked.toString());
    }

    const handleModalPayNowClick = () => {
        setOpenPaymentInstructModal(false);
        setExpanded(true);
        setTimeout(() => {
            paymentSectionRef?.current?.scrollIntoView({ behavior: 'smooth' });
        }, 300);
    };

    const campaignIdfromsuccess = localStorage.getItem('campaignid');

    const getVerifyingScript = async (campaignId: string) => {
        try {
            const response = await getverifyscript({ userid: user_email || getCookie('user_email') || "", campaingid: campaignId || '' });
            if ('data' in response) {
                console.log('cnameentries=>', response.data.script);
                setScript(response.data.script);
            }
        } catch (error) {
            console.log('fetching error', error);
        }
    }

    const handleVerifyCheckClick = async (campaignId: string) => {
        try {
            const response = await getcheckverified({ userid: user_email || getCookie('user_email') || "", campaingid: campaignId || '' });
            if ('data' in response) {
                console.log('cnameentries=>', response.data.status);
                setVerifyCheck(response.data.status);
                localStorage.removeItem('campaignid');
            }
        } catch (error) {
            console.log('fetching error', error);
        }
    }

    const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length > 0) {
            const file = e.target.files[0];
            const imageUrl = URL.createObjectURL(file);
            setUserImage(file);
            setUserImageUrl(imageUrl);
            return () => URL.revokeObjectURL(imageUrl);
        }
    };

    const handleUpdateSetting = async (campaignId: string) => {
        setIsUpdateLoader(true);
        let formData = new FormData();
        formData.append('name', name != "" && name != undefined ? name : planDetails?.name === undefined ? userDetails?.first_name : planDetails.name);
        formData.append('campaignid', campaignId);
        if (userImage) {
            formData.append('user_image', userImage);
        }

        const element = document.getElementById("authurl") as HTMLInputElement;
        if (element.value) {
            formData.append('social_url', element.value);
        } else {
            formData.append('social_url', socialUrl);
        }

        const element1 = document.getElementById("usedefault") as HTMLInputElement;
        if (element1.checked) {
            formData.append('use_as_default', '1');
        } else {
            formData.append('use_as_default', useAsDefault ? '1' : '0');
        }

        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + '/api/prompts/updateAuthorinfo', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            if (response.data.status == "success") {
                const randomNumber = Math.random();
                setUserImageUrl(response.data.user_image + "?" + randomNumber);
            }
            else {
                toast.error("Somethng went wrong..")
            }
            console.log(response.data);
        } catch (error) {
            console.error('Error updating author settings:', error);
        } finally {
            setIsUpdateLoader(false);
        }
    };

    const fetchCourseDetails = async (courseId: string) => {
        try {
            setIsLoadingCourse(true);
            const apiUrl = process.env.REACT_APP_SERVER_ENDPOINT || "";
            const { data } = await axios.post<GetCourseDetailsResponse>(
                `${apiUrl}/api/prompts/get_course_details`,
                { course_id: courseId }
            );
            if (data?.result?.expertise) {
                console.log("stored expertise");
                //setExpertise(data.result.expertise);
            }
        } catch (error: any) {
            console.error("Failed to fetch course details", error);
            toast.error(
                error?.response?.data?.detail || "Failed to load course details"
            );
        } finally {
            setIsLoadingCourse(false);
        }
    };

    useEffect(() => {
        const storedCourseId = localStorage.getItem("course_id");
        if (storedCourseId) {
            fetchCourseDetails(storedCourseId);
        }
    }, []);

    useEffect(() => {
        if (campDetails?.social_url)
            setSocialUrl(campDetails?.social_url);
        if (campDetails?.name)
            setName(campDetails?.name);
        if (campDetails?.use_as_default == 1)
            setUseAsDefault(true);
    }, [campDetails]);

    useEffect(() => {
        if (!campDetails?.social_url && userDetails?.social_url)
            setSocialUrl(userDetails?.social_url);
        if (!name)
            setName(userDetails?.first_name);
    }, [userDetails]);

    useEffect(() => {
        const storedCampaignName = localStorage.getItem('campaignName');
        if (storedCampaignName) setCampaignName(storedCampaignName);
        const storedAuthorName = localStorage.getItem('Authorname');
        if (storedAuthorName) setName(storedAuthorName);
        const storedAuthorurl = localStorage.getItem('Authorurl');
        if (storedAuthorurl) setSocialUrl(storedAuthorurl);
        const storedSourceUrl = localStorage.getItem('sourceurl');
        if (storedSourceUrl) setSourceUrl(storedSourceUrl);
        const storedSourceText = localStorage.getItem('sourcetext');
        if (storedSourceText) setSourceText(storedSourceText);
        const storedPodcastUrl = localStorage.getItem('podcastUrl');
        if (storedPodcastUrl) setPodcastOrYoutubeUrl(storedPodcastUrl);
        const storedtwitterUrl = localStorage.getItem('twitterurl');
        if (storedtwitterUrl) settwitterUrl(storedtwitterUrl);
        const storedFBUrl = localStorage.getItem('fburl');
        if (storedFBUrl) setfbUrl(storedFBUrl);
        const storedpintrestUrl = localStorage.getItem('pintresturl');
        if (storedpintrestUrl) setPintrestUrl(storedpintrestUrl);
        const storedLinkedinUrl = localStorage.getItem('linkedinurl');
        if (storedLinkedinUrl) setLinkedinUrl(storedLinkedinUrl);
        const payment_opt = localStorage.getItem('paymentOption');
        if (payment_opt) setPaymentOption(payment_opt);
        const storedAutoPublish = localStorage.getItem('autoPublish');
        if (storedAutoPublish !== null) setAutopublish(storedAutoPublish === 'true');
        const storedLimitPublish = localStorage.getItem('limitPublish');
        if (storedLimitPublish !== null) setLimitPublish(storedLimitPublish === 'true');
        const storedsocialMediaurlsPublish = localStorage.getItem('smUrlpublish');
        if (storedsocialMediaurlsPublish !== null) setSocialMediaUrlPublish(storedsocialMediaurlsPublish === 'true');
        const storedAddTags = localStorage.getItem('addTags');
        if (storedAddTags !== null) setAddTags(storedAddTags === 'true');
        const storedcaptureLeads = localStorage.getItem('captureLeads');
        if (storedcaptureLeads !== null) setCapturLeads(storedcaptureLeads === 'true');
        const storednewsLetter = localStorage.getItem('newsLetter');
        if (storednewsLetter !== null) setNewsLetter(storednewsLetter === 'true');
        const storedtwitterBtn = localStorage.getItem('twitterBtn');
        if (storedtwitterBtn !== null) setTwitternButton(storedtwitterBtn === 'true');
        const storedfbBtn = localStorage.getItem('fbBtn');
        if (storedfbBtn !== null) setFbButton(storedfbBtn === 'true');
        const storedpintrestBtn = localStorage.getItem('pintrestBtn');
        if (storedpintrestBtn !== null) setPintrestButton(storedpintrestBtn === 'true');
        const storedlinkedinBtn = localStorage.getItem('linkedinBtn');
        if (storedlinkedinBtn !== null) setLinkedinButton(storedlinkedinBtn === 'true');
        const storedvideo = localStorage.getItem('video');
        if (storedvideo !== null) setVideo(storedvideo === 'true');
        const storedAuthorDefCheck = localStorage.getItem('authorDefaultCheck');
        if (storedAuthorDefCheck !== null) setUseAsDefault(storedAuthorDefCheck === 'true');
    }, []);

    const handleCampaignNameChange = (event: any) => {
        const newName = event.target.value;
        if (newName === planDetails?.product_name) {
            toast.error('Already campaign name exist!');
        } else {
            setCampaignName(newName);
            if (planDetails) {
                setPlanDetails({
                    ...planDetails,
                    product_name: newName
                });
            }
            localStorage.setItem('campaignName', newName);
        }
    };

    const handleAuthorNameChange = (event: any) => {
        const newName = event.target.value;
        setName(newName);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                name: newName
            });
        } else if (userDetails) {
            setUserDetails({
                ...userDetails,
                name: newName
            });
        }
        localStorage.setItem('Authorname', newName);
    }

    const handleAuthorUrlChange = (event: any) => {
        const newUrl = event.target.value;
        setSocialUrl(newUrl);
        if (campDetails) {
            setCampDetails({
                ...campDetails,
                social_url: newUrl
            });
        } else if (userDetails) {
            setUserDetails({
                ...userDetails,
                social_url: newUrl
            });
        }
        localStorage.setItem('Authorurl', newUrl);
    }

    const handleCopyName = (name: string) => {
        navigator.clipboard.writeText(name).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
        })
    }

    const handleCopyscript = (script: string) => {
        navigator.clipboard.writeText(script).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
        })
    }

    const handleCopyVal = (value: string) => {
        navigator.clipboard.writeText(value).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
        })
    }

    const placeholderText = 'https://www.youtube.com/watch?v=X7sEkixKk4g&t=1s';
    const code_snippet = script;

    useEffect(() => {
        setUserImageUrl(planDetails?.user_image || campDetails?.user_image);
    }, [planDetails]);

    const NormallyValArray = [period == "monthly" ? '' : 'Normally $14/mo.', period == "monthly" ? '' : 'Normally $49/mo.', period == "monthly" ? '' : 'Normally $99/mo.', period == "monthly" ? '' : 'Normally $149/mo.'];

    const handleChangePayMethodClick = async () => {
        localStorage.setItem('ChangepayMode', 'true');
        localStorage.setItem('IdChangingMode', campIdFrEdit);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + `/api/subscription/change_payment_method?email=${user_email}`, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (response.data.status === 'success') {
                window.open(response.data.portal_url, '_blank');
            }
        } catch (error) {
            console.log('Error changing payment method', error);
        }
    }

    const handleCancelSubscriptionClick = async () => {
        setCancellingLoader(true);
        try {
            const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
            const response = await axios.post(apiUrl + `/api/subscription/Cancel_Subscription?campaign_id=${campIdFrEdit}`, {
                headers: { 'content-type': 'multipart/form-data' }
            });
            if (response.data.status === 'success') {
                setSuccessCancelSubscription(true);
                setConfirmCancelSubscription(false);
                toast.success('Cancelled Subscription!');
            }
        } catch (error) {
            toast.error('Error cancelling subscription');
            console.log('Error cancelling subscription', error);
        } finally {
            setCancellingLoader(false);
        }
    }

    const currentlocationurl = window.location.origin;
    const addtoMyblogscodeSnippet =
        `<iframe src="${currentlocationurl}/blogs?campaignid=${campIdFrEdit}&header=off" height="600" width="900" title="Iframe Example"></iframe>`;

    const handleCopyCodeSnippet = (value: string) => {
        navigator.clipboard.writeText(value).then(() => {
            toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
                style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
            });
        })
    }

    const handleuploadvideoChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const apiUrl: string = process.env.REACT_APP_UPLOAD_SERVER_ENDPOINT || "";
        const CHUNK_SIZE = 10 * 1024 * 1024;
        const CONCURRENCY = 20;
        const RETRIES = 3;

        if (urlPrefix === "word" || urlPrefix === "pdf") {
            setLoadingText("Uploading your document...");
        } else {
            setLoadingText("Uploading your video...");
        }
        setUploadVideo(file.name);
        setIsLoadingGetPage(true);
        setLoaderProgress(0);

        const splitIntoChunks = (f: File, chunkSize: number) => {
            const parts: { index: number; start: number; end: number; blob: Blob }[] = [];
            let idx = 0;
            for (let start = 0; start < f.size; start += chunkSize) {
                const end = Math.min(start + chunkSize, f.size);
                parts.push({ index: idx++, start, end, blob: f.slice(start, end) });
            }
            return parts;
        };

        const initUpload = async (filename: string, totalSize: number, chunkSize: number) => {
            const form = new FormData();
            form.append("filename", filename);
            form.append("total_size", String(totalSize));
            form.append("chunk_size", String(chunkSize));
            const resp = await axios.post(`${apiUrl}/upload/init`, form);
            return resp.data as { upload_id: string; total_chunks: number; chunk_size: number };
        };

        const getStatus = async (uploadId: string) => {
            try {
                const resp = await axios.get(`${apiUrl}/upload/${uploadId}/status`);
                return resp.data as { uploaded: number[] };
            } catch (err) {
                return { uploaded: [] };
            }
        };

        const uploadChunk = async (uploadId: string, index: number, blob: Blob) => {
            const form = new FormData();
            form.append("index", String(index));
            form.append("chunk", blob, `chunk_${index}`);
            return axios.post(`${apiUrl}/upload/${uploadId}/chunk`, form, {
                headers: { "Content-Type": "multipart/form-data" },
                timeout: 0,
            });
        };

        const completeUpload = async (uploadId: string) => {
            const resp = await axios.post(`${apiUrl}/upload/${uploadId}/complete`);
            return resp.data;
        };

        try {
            let uploadId: string | null = null;
            let initResp: { upload_id: string; total_chunks: number; chunk_size: number } | null = null;

            if (uploadId) {
                const status = await getStatus(uploadId);
                if (!status || !Array.isArray(status.uploaded)) {
                    uploadId = null;
                    localStorage.removeItem(`upload_id:${file.name}`);
                }
            }

            if (!uploadId) {
                initResp = await initUpload(file.name, file.size, CHUNK_SIZE);
                uploadId = initResp.upload_id;
                localStorage.setItem(`upload_id:${file.name}`, uploadId);
            } else {
                initResp = {
                    upload_id: uploadId,
                    total_chunks: Math.ceil(file.size / CHUNK_SIZE),
                    chunk_size: CHUNK_SIZE,
                };
            }

            const chunks = splitIntoChunks(file, CHUNK_SIZE);
            const statusResp = await getStatus(uploadId);
            const uploadedSet = new Set<number>((statusResp.uploaded || []).map((n: number) => Number(n)));
            const pending = chunks.filter((c) => !uploadedSet.has(c.index));

            if (pending.length === 0) {
                const comp = await completeUpload(uploadId);
                setUploadedvideopath(comp.data || comp);
                toast.success("File Uploaded Successfully!");
                setLoaderProgress(100);
                setTimeout(() => setIsLoadingGetPage(false), 1000);
                return;
            }

            let uploadedBytes = (chunks.length - pending.length) * CHUNK_SIZE;
            const totalBytes = file.size;
            setLoaderProgress(Math.round((uploadedBytes / totalBytes) * 100));

            const queue = [...pending];
            const uploadWorker = async () => {
                while (queue.length > 0) {
                    const c = queue.shift();
                    if (!c) break;
                    let attempt = 0;
                    while (attempt < RETRIES) {
                        attempt++;
                        try {
                            await uploadChunk(uploadId!, c.index, c.blob);
                            uploadedBytes += c.end - c.start;
                            const pct = Math.min(100, Math.round((uploadedBytes / totalBytes) * 100));
                            setLoaderProgress(10 + Math.round(pct * 0.85));
                            break;
                        } catch (err) {
                            console.warn(`Chunk ${c.index} attempt ${attempt} failed`, err);
                            if (attempt >= RETRIES) throw err;
                            await new Promise((res) => setTimeout(res, 500 * attempt));
                        }
                    }
                }
            };

            const workers = new Array(Math.min(CONCURRENCY, pending.length)).fill(null).map(() => uploadWorker());
            await Promise.all(workers);

            setLoaderProgress(95);
            const completeResp = await completeUpload(uploadId);
            const finalPath = completeResp.data || completeResp;
            setUploadedvideopath(finalPath);
            toast.success("File Uploaded Successfully!");
            localStorage.removeItem(`upload_id:${file.name}`);
            setLoaderProgress(100);
        } catch (err) {
            console.error("Upload failed", err);
            toast.error("Error uploading video");
            setLoaderProgress(0);
        } finally {
            setTimeout(() => setIsLoadingGetPage(false), 1000);
        }
    };

    useEffect(() => {
        setNewsLetter(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setCapturLeads(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setTwitternButton(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setFbButton(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setLinkedinButton(!!planDetails?.embed_contact_form_newsletters_social_media_share);
        setVideo(!!planDetails?.embed_youtube_video);
    }, [planDetails]);

    const clearCookies = () => {
        const cookies = document.cookie.split("; ");
        for (const cookie of cookies) {
            const [name] = cookie.split("=");
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        }
    };

    const handleItemClick = (itemName: any) => {
        localStorage.setItem('activeItem', itemName);
        setActiveItem(localStorage.getItem('activeItem') ? localStorage.getItem('activeItem') : itemName);
        localStorage.removeItem('campaignid');
        localStorage.removeItem('returningtocampaign');
        localStorage.removeItem('sourceurl');
        localStorage.removeItem('campaignName');
        localStorage.removeItem('paymentOption');
        localStorage.removeItem('autoPublish');
        localStorage.removeItem('limitPublish');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('addTags');
        localStorage.removeItem('captureLeads');
        localStorage.removeItem('newsLetter');
        localStorage.removeItem('twitterBtn');
        localStorage.removeItem('fbBtn');
        localStorage.removeItem('pintrestBtn');
        localStorage.removeItem('linkedinBtn');
        localStorage.removeItem('video');
        localStorage.removeItem('twitterurl');
        localStorage.removeItem('fburl');
        localStorage.removeItem('pintresturl');
        localStorage.removeItem('linkedinurl');
        localStorage.removeItem('smUrlpublish');
        localStorage.removeItem('owndomain');
        localStorage.removeItem('ChangepayMode');
        localStorage.removeItem('IdChangingMode');
        localStorage.removeItem('PaymentSubscription');
        localStorage.removeItem('Authorurl');
        localStorage.removeItem('Authorname');
        localStorage.removeItem('authorDefaultCheck');
        localStorage.removeItem('videoTag');
        localStorage.removeItem('podcastUrl');
        localStorage.removeItem('sourcetext');

        if (itemName == 'createcontent') {
            navigate('/codegenie/new-podcast');
        } else if (itemName == 'createcourse') {
            navigate('/codegenie/new-course-2-1');
        } else if (itemName === 'course') {
            navigate('/codegenie/generated-courses');
        } else {
            navigate('/codegenie/generated-blogs');
        }

        if (itemName === 'upgrade') {
            localStorage.setItem('fromUpgrade', 'true');
            navigate('/pricing', { state: { campIdFromUpgrade: localStorage.getItem('campId') || '', from_page: 'blog_listing' } });
        } else if (itemName === 'logout') {
            clearCookies();
            localStorage.setItem("logged_in", "false");
            dispatch(logout());
            var module = localStorage.getItem("module");
            toast.success("Logout success");
            localStorage.removeItem("msg");
            localStorage.removeItem("complexity");
            localStorage.removeItem("module");
            localStorage.removeItem("subscription_level");
            localStorage.removeItem("free_plan");
            localStorage.removeItem("localStorage_msg");
            localStorage.removeItem("allSet");
            localStorage.removeItem("Blogs Generated");
            localStorage.removeItem("remaining_wish_count");
            localStorage.removeItem("userRole");
            localStorage.removeItem("payment");
            localStorage.removeItem("user_email");
            localStorage.removeItem("logged_in");
            localStorage.removeItem("prevImg");
            localStorage.removeItem("fromUpgrade");
            localStorage.removeItem("blogsCount");
            localStorage.removeItem("Generating Count");
            localStorage.removeItem("finalData");
            localStorage.removeItem("user_pass");
            localStorage.removeItem("fromNewcampaign");
            localStorage.removeItem("campaignid");
            localStorage.removeItem("returningtocampaign");
            localStorage.removeItem('sourceurl');
            localStorage.removeItem('campaignName');
            localStorage.removeItem('paymentOption');
            localStorage.removeItem('autoPublish');
            localStorage.removeItem('limitPublish');
            localStorage.removeItem('campId');
            localStorage.removeItem('smUrlpublish');
            localStorage.removeItem('addTags');
            localStorage.removeItem('captureLeads');
            localStorage.removeItem('newsLetter');
            localStorage.removeItem('twitterBtn');
            localStorage.removeItem('fbBtn');
            localStorage.removeItem('pintrestBtn');
            localStorage.removeItem('linkedinBtn');
            localStorage.removeItem('video');
            localStorage.removeItem('twitterurl');
            localStorage.removeItem('fburl');
            localStorage.removeItem('pintresturl');
            localStorage.removeItem('linkedinurl');
            localStorage.removeItem('owndomain');
            localStorage.removeItem('ChangepayMode');
            localStorage.removeItem('IdChangingMode');
            localStorage.removeItem('user_name');
            localStorage.removeItem('refreshCount');
            localStorage.removeItem('publishingCampId');
            localStorage.removeItem('Authorurl');
            localStorage.removeItem('Authorname');
            localStorage.removeItem('authorDefaultCheck');
            localStorage.removeItem('appsumo_coupon_code');
            localStorage.removeItem('podcastUrl');
            localStorage.removeItem('AlertMessage');
            localStorage.removeItem('CreatingfromLanding');
            localStorage.removeItem('UrlfromLanding');
            localStorage.removeItem('signedup');
            localStorage.removeItem('uploadedvideo');
            localStorage.removeItem('uploadedVideoName');
            localStorage.removeItem('uploadStatus');
            localStorage.removeItem('editedposthashtags');
            localStorage.removeItem('editedpostblogsummary');
            localStorage.removeItem('editedpostblogtitle');
            localStorage.removeItem('editedposturl');
            localStorage.removeItem('user_email');
            localStorage.removeItem('YoutubeUrlfromLanding');
            localStorage.removeItem('FirstLogin');
            localStorage.removeItem('DirectSignup');
            localStorage.removeItem('FromIndexPage');
            localStorage.removeItem('activeItem');
            localStorage.removeItem('UpdateduserImage');
            localStorage.removeItem('publish_to_code_genie');
            localStorage.removeItem('publish_to_ocesha');
            localStorage.removeItem('competitor_search');
            localStorage.removeItem('FromEditBlog');
            localStorage.removeItem('ErrorAlert');
            localStorage.removeItem('FromSignIn');
            // also clear DT session on logout
            localStorage.removeItem('dt_session_id');
            localStorage.removeItem('dt_current_question');
            localStorage.removeItem('dt_current_stage');
            localStorage.removeItem('dt_session_history');
            removeCookie('user_email');
            localStorage.clear();

            if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
                navigate("/Anycode_landing");
            else
                window.location.href = process.env.REACT_APP_LOGOUT_DOMAIN||''; //"https://ocesha.ai";
        }
    };

    const handleMenuToggle = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleTopicSelect = (topic: any) => {
        setSelectedTopic(topic);
    }

    const handleKeywordSelect = (keyword: any) => {
        setSelectedKeyword(keyword);
    };

    const stopAllAudio = () => {
       stopAll();
        audioManager.stop();

        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }

        if (expertiseAudioRef.current) {
            expertiseAudioRef.current.pause();
            expertiseAudioRef.current.currentTime = 0;
        }

        // ADD THIS BLOCK
        if (questionAudioRef.current) {
            questionAudioRef.current.pause();
            questionAudioRef.current.currentTime = 0;
        }

        setCurrentAudioType(null);
    };

    // auto play intro(SPEAKER)
    const secondAudio =
        "https://texttospeachservice.ocesha.ai/media/8582c305-293f-4d9d-997e-8b9e7581b16d.wav";

    const location_audio = useLocation();
    
    useEffect(() => {

        stopAllAudio();
       

    }, [location_audio.pathname]);

    useEffect(() => {
        stopAllAudio();
        if (!userDetails?.first_name || hasFetched.current) return;

        hasFetched.current = true;
        fetchAudio();
    }, [userDetails?.first_name]);


    const fetchAudio = async () => {
        try {
            // Site language other than English: "Hi <name>" and the intro clip in that
            // language (WAVs generated once per language and reused, see utils/voiceClips.ts)
            localizedClipUrl(secondAudio).then((u) => { localizedIntro.current = u; }).catch(() => {});
            const localizedGreeting = await getGreetingUrl(userDetails?.first_name || "").catch(() => null);
            if (localizedGreeting) { playAudio(localizedGreeting); return; }

            const res = await axios.post(
                `${process.env.REACT_APP_TEXT_TO_SPEECH_SERVICE}/speak?text=${`Hi ${userDetails?.first_name}`}`,
                /* {
                    text: `Hi ${userDetails?.name}`,
                } */
            );

            // const data = await res.json();
            const data = res?.data;

            if (data?.audio_path) {
                playAudio(data.audio_path);
            }
        } catch (err) {
            console.error("Error fetching audio:", err);
        }
    };

    const playAudio = (url: string) => {
        audioManager.stop();
        
        if (expertiseAudioRef.current) {
            expertiseAudioRef.current.pause();
        }

        const audio = new Audio(url);
        audioRef.current = audio;
        setCurrentAudioType("intro");

        // Respect mute state
        audio.muted = isMuted;

        const playPromise = audio.play();
        if (playPromise !== undefined) {
            playPromise.catch((err) => {
                console.log("Autoplay blocked, waiting for user gesture:", err);
                // Retry on first user interaction
                const retryPlay = () => {
                    audio.play().catch(() => { });
                    document.removeEventListener("click", retryPlay);
                    document.removeEventListener("keydown", retryPlay);
                };
                document.addEventListener("click", retryPlay, { once: true });
                document.addEventListener("keydown", retryPlay, { once: true });
            });
        }

        audio.onended = () => {
            // 1st audio finished — chain into secondAudio (DO NOT stopAllAudio here,
            // because that would kill the audio we're about to create)
            const nextAudio = new Audio(localizedIntro.current || secondAudio);
            audioRef.current = nextAudio;
            nextAudio.muted = isMuted;
            nextAudio.play().catch(() => { });

            nextAudio.onended = () => {
                setCurrentAudioType(null);
                if (sessionHistory.length > 0)
                    setCurrentQuestion(sessionHistory[questionIndex].question);

                // secondAudio finished — NOW the question audio is allowed to play
                setIntroDone(true);
            };
        };

        // audio.onended = () => {
        //     setCurrentAudioType(null);
        // };
    };

    // INTRO speaker — only controls intro audio, nothing else
    /*const toggleMute = () => {
        if (!audioRef.current) return;

        if (currentAudioType !== "intro") {
            stopAllAudio(); //  stop others

            audioRef.current.play();
            setCurrentAudioType("intro");
            setIsMuted(false);
        } else {
            audioRef.current.pause();
            setCurrentAudioType(null);
            setIsMuted(true);
        }
    };*/

    const toggleMute = () => {
        const newMuted = !isMuted;
        setIsMuted(newMuted);
        (window as any).isMutedGlobal = newMuted;
        audioManager.applyMute(newMuted);

        // Also apply to our own refs so currently-playing audio mutes/unmutes immediately
        if (audioRef.current) audioRef.current.muted = newMuted;
        if (expertiseAudioRef.current) expertiseAudioRef.current.muted = newMuted;
        if (questionAudioRef.current) questionAudioRef.current.muted = newMuted;

        // Keep the secondary flag in sync so the question useEffect can never disagree
        setIsExpertiseMuted(newMuted);
    };

    const handleMuteLogic = () => {
        console.log(" MUTE LOGIC RUNNING");

        if (audioRef.current) {
            audioRef.current.pause();
            audioRef.current.currentTime = 0;
        }

        if (expertiseAudioRef.current) {
            expertiseAudioRef.current.pause();
        }

        console.log("questionText:", questionText);

        if (currentQuestion) {
            stopAllAudio(); 
            fetchExpertiseSpeech(currentQuestion);
        } else {
            console.log("questionText EMPTY");
        }
    };

    /*
    // REMOVE this useEffect entirely — it caused the intro speaker to trigger question audio
    useEffect(() => {
        if (currentQuestion && shouldPlayQuestion.current) {
            fetchExpertiseSpeech(currentQuestion);
            shouldPlayQuestion.current = false;
        }
    }, [currentQuestion]);*/

    // questionnaire speaker
    /* const playExpertiseAudio = (url: string) => {
        if (expertiseAudioRef.current) {
            expertiseAudioRef.current.pause();

            // cleanup old blob URL
            if (expertiseAudioRef.current.src.startsWith("blob:")) {
                URL.revokeObjectURL(expertiseAudioRef.current.src);
            }
        }

        const audio = new Audio(url);
        expertiseAudioRef.current = audio;

        if (!isExpertiseMuted) {
            audio.play().catch((err) => {
                console.log("Play blocked:", err);
            });
        }
    }; */
    const playExpertiseAudio = (url: string) => {
        
        stopAllAudio();

        // Stop intro audio
        if (audioRef.current) {
            audioRef.current.pause();
        }

        // Stop any existing question audio
        if (expertiseAudioRef.current) {
            expertiseAudioRef.current.pause();
            // Revoke old blob URL to free memory
            if (expertiseAudioRef.current.src.startsWith("blob:")) {
                URL.revokeObjectURL(expertiseAudioRef.current.src);
            }
        }

        const audio = new Audio(url);
        expertiseAudioRef.current = audio;
        setCurrentAudioType("question");

        // Only play if question speaker is NOT muted
        if (!isExpertiseMuted) {
            audio.play().catch(() => { });
        }

        // Cleanup blob URL after audio ends
        audio.onended = () => {
            if (url.startsWith("blob:")) {
                URL.revokeObjectURL(url);
            }
            setCurrentAudioType(null);
        };
    };

    const fetchExpertiseSpeech = async (text: string) => {
        console.log(" speak_stream CALLED:", text);
        
        try {
            

            const res = await axios.post(
                `${process.env.REACT_APP_TEXT_TO_SPEECH_SERVICE}/speak?text=${text}`,
            );

            const data = res?.data;

            if (data?.audio_path) {
                stopAllAudio();
                setCurrentAudioType("question");
                playExpertiseAudio(data.audio_path);
            }


        } catch (err) {
            console.error("TTS error:", err);
        }
    };

    /* useEffect(() => {
        const timer = setTimeout(() => {
            if (questionText) {
                fetchExpertiseSpeech(questionText);
            }
        }, 600);

        return () => clearTimeout(timer);
    }, [questionText]); */

    // QUESTION speaker — fetches and plays current question audio
    const toggleExpertiseMute = () => {
        if (!expertiseAudioRef.current) return;

        if (currentAudioType !== "question") {
            stopAllAudio(); // VERY IMPORTANT

            expertiseAudioRef.current.play();
            setCurrentAudioType("question");
            setIsExpertiseMuted(false);
        } else {
            expertiseAudioRef.current.pause();
            setCurrentAudioType(null);
            setIsExpertiseMuted(true);
        }
    };

    const playQuestionAudio = (audioPath: string) => {
        if (!audioPath) return;
        stopAllAudio();
        const audio = new Audio(audioPath);
        audio.muted = isMuted;            // respect mute immediately
        questionAudioRef.current = audio; // so stopAllAudio can pause it
        setCurrentAudioType("question");

        audio.addEventListener("ended", () => {
            setCurrentAudioType(null);
        });
        audioManager.play(audio, "question");
    };

    useEffect(() => {
        if (!currentAudioPath) return;
        if (isMuted) return;
        if (!introDone) return;       // ← wait for intro+secondAudio to finish
        stopAllAudio();
        playQuestionAudio(currentAudioPath);
    }, [currentAudioPath, introDone]);


    useEffect(() => {
        const el = chatScrollRef.current;
        if (!el) return;
        requestAnimationFrame(() => {
            el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
        });
    }, [chatMessages, isChatLoading]);

    const steps = [
          "About You",
          "Content Sources",
          "Your Expertise",
          "Preferences",
        ];

    const activeStep = 2;

    // useEffect(() => {
    //     console.log({
    //         isPlaying,
    //         isMuted,
    //         currentAudioType,
    //     });
    // }, [isPlaying, isMuted, currentAudioType]);

    const isSpeakerAnimating = (currentAudioType !== null || isPlaying) && !isMuted; 

    return (
        <>
            <div style={{ overflowX: 'hidden' }}>
                <div className="row">

                    <div className={FromSignUp === 'true' ? "col-sm-12 col-md-12 col-lg-12" : "col-sm-12 col-md-10 col-lg-10"}>
                        {/* <Ocesha_header handleItemClick={handleItemClick} FromSignUp={FromSignUp} /> */}
                        {FromSignUp === 'true' ? <Divider sx={{ mt: 2 }} /> : <hr />}
                        <div className="overlay-container" style={{ paddingRight: FromSignUp === 'true' ? '10%' : undefined, paddingLeft: FromSignUp === 'true' ? '10%' : undefined }}>
                            <div style={{ width: '98%', marginBottom: '10%' }}>
                                {isloadingGetPage && !getPageError && (
                                    <div style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                        zIndex: 9999,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backdropFilter: 'blur(5px)',
                                        overflow: 'hidden',
                                    }}>
                                        <div style={{
                                            width: '80%', maxWidth: '700px',
                                            padding: '20px',
                                            backgroundColor: '#282C39',
                                            borderRadius: '8px',
                                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                            textAlign: 'center'
                                        }}>
                                            <Typography style={{ fontSize: '30px' }}>{loadingText}</Typography>
                                            <br></br>
                                            <ProgressBar
                                                completed={loaderProgress}
                                                bgColor={loaderProgress >= 90 ? "#4CAF50" : "#4BA5EB"}
                                                height="20px"
                                                labelColor="#ffffff"
                                                labelAlignment="center"
                                            />
                                            <br></br>
                                            <Typography style={{ fontSize: '20px' }}>Sit tight, your content monster AI Agents have got you covered …...</Typography>
                                        </div>
                                    </div>
                                )}

                                {planDetails?.payment_status === 'pending' ?
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Box sx={{ background: '#090619', borderRadius: '5px', padding: isMobile ? '6%' : '2%', width: isMobile ? '100%' : '50%', }}>
                                                <Typography sx={{ fontSize: '15px', fontWeight: 'bolder', color: "#fff" }}><span style={{ display: 'flex', justifyContent: 'center', marginBottom: '2%' }}><InfoIcon style={{ color: 'Orange', fontSize: '30px' }} /></span><span style={{ display: 'flex', justifyContent: 'center' }}>{'Note: Subscription is PENDING, please complete the payment.'}</span></Typography>
                                            </Box>
                                        </Grid>
                                    </Grid> : ''}

                                <div className="row gx-2">

                                    {/* LEFT: Rohan card */}
                                    <div className="col-sm-12 col-md-4 col-lg-4 py-4" style={{ paddingLeft: '1.5rem' }}>
                                        <Box
                                            sx={{
                                                position: "relative",
                                                display: "block",
                                                width: "100%",
                                                overflow: "visible",
                                            }}
                                        >
                                            {/* Rohan image — no bump animation */}
                                            <Box
                                                component="img"
                                                src={RohanImg}
                                                alt="Rohan Hall"
                                                sx={{
                                                    position: "relative",
                                                    zIndex: 1,
                                                    width: "100%",
                                                    display: "block",
                                                    objectFit: "cover",
                                                }}
                                            />

                                            {/* Waveform bars — overlaid on the bottom of the image */}
                                            <Box
                                                sx={{
                                                    display: isSpeakerAnimating ? "flex" : "none",
                                                    position: "absolute",
                                                    left: 0,
                                                    right: 0,
                                                    bottom: "16px",          // distance from the bottom edge of the image
                                                    zIndex: 2,
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    gap: "3px",
                                                    height: "48px",
                                                    px: 2,
                                                    pointerEvents: "none",   // so it doesn't block clicks on the image
                                                    background: "linear-gradient(180deg, transparent 0%, rgba(0,0,0,0.35) 100%)",
                                                }}
                                            >
                                                {[
                                                    4, 10, 18, 8, 22, 14, 26, 6, 16, 30, 12, 20, 8, 24, 10, 18, 4, 14, 22, 8,
                                                    16, 28, 10, 20, 6, 24, 12, 18, 8, 14, 26, 10, 16, 22, 6, 20, 12, 8, 24, 14,
                                                ].map((peak, i) => (
                                                    <Box
                                                        key={i}
                                                        sx={{
                                                            width: "2.5px",
                                                            minWidth: "2.5px",
                                                            borderRadius: "2px",
                                                            background: "#3B82F6",
                                                            animation: `waveStrip${i} 1.1s ease-in-out infinite`,
                                                            animationDelay: `${(i % 10) * 0.08}s`,
                                                            [`@keyframes waveStrip${i}`]: {
                                                                "0%, 100%": { height: "6px" },
                                                                "50%": { height: `${peak}px` },
                                                            },
                                                        }}
                                                    />
                                                ))}
                                            </Box>
                                        </Box>

                                        <Paper
                                          sx={{
                                            background:
                                              "linear-gradient(180deg, rgba(11,12,20,1) 0%, rgba(10,14,28,1) 100%)",
                                            borderTopLeftRadius: 0,
                                            borderTopRightRadius: 0,
                                            borderBottomLeftRadius: "16px",
                                            borderBottomRightRadius: "16px",
                                            border: "1px solid rgba(255,255,255,0.08)",
                                            p: 3,
                                            mb: 2,
                                          }}
                                        >
                                          <Box position="relative"
                                          sx={{
                                              maxHeight: "300px", // fixed height
                                              overflowY: "auto",
                                              pr: 1, // space for scrollbar

                                              // Thin scrollbar
                                              "&::-webkit-scrollbar": {
                                                width: "4px",
                                              },
                                              "&::-webkit-scrollbar-track": {
                                                background: "transparent",
                                              },
                                              "&::-webkit-scrollbar-thumb": {
                                                background: "rgba(255,255,255,0.18)",
                                                borderRadius: "10px",
                                              },
                                              "&::-webkit-scrollbar-thumb:hover": {
                                                background: "rgba(255,255,255,0.3)",
                                              },

                                              // Firefox
                                              scrollbarWidth: "thin",
                                              scrollbarColor: "rgba(255,255,255,0.18) transparent",
                                            }}>

                                            {/* TOP LABEL */}
                                            <Typography
                                              sx={{
                                                fontSize: "11px",
                                                letterSpacing: "0.08em",
                                                color: "#4BA5EB",
                                                mb: 1,
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                              }}
                                            >
                                              <AutoAwesomeIcon sx={{ fontSize: 18 }} /> MEET YOUR AI CONCIERGE
                                            </Typography>

                                            {/* TITLE */}
                                            <Typography
                                              sx={{
                                                color: "#fff",
                                                fontSize: "22px",
                                                fontWeight: 600,
                                                mb: 1.5,
                                              }}
                                            >
                                              Hi {userDetails?.first_name},
                                            </Typography>

                                            {/* DESCRIPTION */}
                                            <Typography
                                              sx={{
                                                color: "#A0AEC0",
                                                fontSize: "14px",
                                                lineHeight: "22px",
                                              }}
                                            >
                                              I’ll ask you a few quick questions to better understand your expertise.
                                              <br /> <br />
                                              Your answers help OceSha create courses that sound like you.
                                              <br /> <br />
                                              This helps OceSha personalize:
                                            
                                            </Typography>
                                            <Box
                                                component="ul"
                                                sx={{
                                                    color: "#A0AEC0",
                                                    fontSize: "14px",
                                                    lineHeight: "22px",
                                                    pl: 3,
                                                    mt: 1,
                                                    mb: 0,
                                                    "& li": { mb: 0.5 },
                                                }}
                                                >
                                                <li>Course content and structure</li>
                                                <li>Lessons and learning materials</li>
                                                <li>Examples and real-world insights</li>
                                                <li>Your AI teaching experience</li>

                                            </Box>
                                            <br />
                                            <Typography
                                              sx={{
                                                color: "#A0AEC0",
                                                fontSize: "14px",
                                                lineHeight: "22px",
                                              }}
                                            >
                                              There are no right or wrong answers — just respond naturally, as if we were having a conversation.

                                              <br /> <br />
                                              You can type your answers or simply speak using your voice.
                                            
                                            </Typography>

                                                                                       

                                          </Box>
                                          {/* Divider */}
                                          <Box
                                            sx={{
                                              mt: 3,
                                              mb: 2,
                                              height: "1px",
                                              background: "rgba(255,255,255,0.08)",
                                            }}
                                          />

                                          {/* Header Row */}
                                          <Stack
                                            direction="row"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            sx={{ mb: 1 }}
                                          >
                                            <Typography sx={{ fontSize: "13px", color: "#D1D5DB" }}>
                                              Onboarding Progress
                                            </Typography>

                                            <Typography sx={{ fontSize: "13px", color: "#A0AEC0" }}>
                                              {activeStep + 1} of {steps.length}
                                            </Typography>
                                          </Stack>

                                          {/* Progress Bar */}
                                          <Box
                                            sx={{
                                              width: "100%",
                                              height: "6px",
                                              borderRadius: "10px",
                                              background: "rgba(255,255,255,0.1)",
                                              overflow: "hidden",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                width: `${((activeStep + 1) / steps.length) * 100}%`,
                                                height: "100%",
                                                borderRadius: "10px",
                                                background: "linear-gradient(90deg, #4BA5EB, #6C63FF)",
                                                transition: "width 0.3s ease",
                                              }}
                                            />
                                          </Box>
                                        </Paper>

                                        {/* Ask box */}
                                        <Paper sx={{ p: 2, background: "#2b2b32", borderRadius: "8px" }}>

                                            {/* Chat messages */}
                                            <Box
                                                ref={chatScrollRef}
                                                sx={{ maxHeight: 200, overflowY: "auto", mb: 1, scrollBehavior: "smooth" }}
                                                >
                                                {chatMessages.map((msg, i) => (
                                                    <Box
                                                        key={i}
                                                        sx={{
                                                            textAlign: msg.role === "user" ? "right" : "left",
                                                            mb: 1,
                                                        }}
                                                    >
                                                        <Typography
                                                            sx={{
                                                                display: "inline-block",
                                                                px: 1.5,
                                                                py: 0.8,
                                                                borderRadius: 2,
                                                                background: msg.role === "user" ? "#4BA5EB" : "#000000",
                                                                color: "#fff",
                                                                fontSize: "14px"
                                                            }}
                                                        >
                                                            <Box sx={{ position: "relative" }}>
                                                                {msg.role === "bot" ? (
                                                                    <Box
                                                                        sx={{
                                                                            "& h3": {
                                                                                fontSize: "15px",
                                                                                fontWeight: "bold",
                                                                                color: "#fff",
                                                                                margin: "6px 0",
                                                                            },
                                                                            "& p": {
                                                                                fontSize: "14px",
                                                                                color: "#D9D9D9",
                                                                                margin: "4px 0",
                                                                            },
                                                                            "& ul": {
                                                                                paddingLeft: "18px",
                                                                                margin: "4px 0",
                                                                            },
                                                                            "& li": {
                                                                                fontSize: "14px",
                                                                                color: "#D9D9D9",
                                                                                marginBottom: "2px",
                                                                            },
                                                                        }}
                                                                        dangerouslySetInnerHTML={{ __html: msg.text }}
                                                                    />
                                                                ) : (
                                                                    msg.text
                                                                )}
                                                            </Box>
                                                        </Typography>
                                                    </Box>
                                                ))}

                                                {isChatLoading && (
                                                    <Typography sx={{ color: "#aaa", fontSize: 12 }}>
                                                        Thinking...
                                                    </Typography>
                                                )}
                                            </Box>

                                            {/* Input */}
                                            <TextareaAutosize
                                                value={questionText}
                                                onChange={(e) => setQuestionText(e.target.value)}
                                                placeholder="Do you have any questions ask me..."
                                                minRows={2}
                                                style={{
                                                    width: "100%",
                                                    background: "#2b2b32",
                                                    color: "#FFFFFF",
                                                    border: "none",
                                                    fontSize: "16px",
                                                    resize: "none",
                                                    outline: "none",
                                                }}
                                            />

                                            {/* Actions */}
                                            <Stack direction="row" justifyContent="flex-end" spacing={1} mt={1}>

                                                {/* SPEAKER */}
                                                {/* <TTSButton text={lastBotText} id="last-bot-message" /> */}
                                                <IconButton
                                                    onClick={toggleMute}
                                                    sx={{
                                                        background: isMuted
                                                            ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
                                                            : "linear-gradient(135deg, #4BA5EB 0%, #1E7BC0 100%)",
                                                        borderRadius: "12px",
                                                        width: 45,
                                                        height: 45,
                                                        boxShadow: isMuted
                                                            ? "0 4px 15px rgba(102,126,234,0.5)"
                                                            : "0 4px 15px rgba(75,165,235,0.5)",
                                                        border: "1px solid rgba(255,255,255,0.2)",
                                                        transition: "all 0.3s ease",
                                                        "&:hover": {
                                                            transform: "scale(1.1)",
                                                            boxShadow: isMuted
                                                                ? "0 6px 20px rgba(102,126,234,0.7)"
                                                                : "0 6px 20px rgba(75,165,235,0.7)",
                                                        },
                                                        animation: !isMuted ? "speakerPulse 2s infinite" : "none",
                                                        "@keyframes speakerPulse": {
                                                            "0%": { boxShadow: "0 4px 15px rgba(75,165,235,0.5)" },
                                                            "50%": { boxShadow: "0 4px 25px rgba(75,165,235,0.9)" },
                                                            "100%": { boxShadow: "0 4px 15px rgba(75,165,235,0.5)" },
                                                        },
                                                    }}
                                                >
                                                    {isMuted ? (
                                                        <VolumeOffIcon sx={{ color: "#fff", fontSize: "22px" }} />
                                                    ) : (
                                                        <VolumeUpIcon sx={{ color: "#fff", fontSize: "22px" }} />
                                                    )}
                                                </IconButton>

                                                {/* MIC */}
                                                <IconButton
                                                    onClick={() =>
                                                        isRecordingQuestion
                                                            ? stopRecording()
                                                            : startRecording("question")
                                                    }
                                                    className={ isRecordingQuestion ? "recording-mic-btn" : "mic-btn" }
                                                >
                                                    <MicNoneOutlinedIcon sx={{ color: "#fff", fontSize: "20px", }} />
                                                </IconButton>
                                                {/* <IconButton
                                                    onClick={handleMicClick}
                                                    sx={{
                                                        animation: isListening ? "pulse 1s infinite" : "none",
                                                        "@keyframes pulse": {
                                                            "0%": { transform: "scale(1)" },
                                                            "50%": { transform: "scale(1.1)" },
                                                            "100%": { transform: "scale(1)" },
                                                        },
                                                    }}
                                                >
                                                    <MicNoneOutlinedIcon sx={{ color: isListening ? "red" : "#fff" }} />
                                                </IconButton> */}

                                                {/* SEND */}
                                                <IconButton
                                                    onClick={() => getChatBotResponse(questionText)}
                                                    sx={{
                                                        border: '1px solid gray',
                                                        borderRadius: '50px',
                                                        background: '#4BA5EB',
                                                        width: 45,
                                                        height: 45,
                                                    }}
                                                >
                                                    <SendIcon sx={{ color: "#fff" }} />
                                                </IconButton>

                                            </Stack>
                                        </Paper>
                                    </div>

                                    {/* RIGHT: Step flow */}
                                    <div className="col-md-8">
                                        <Box sx={{ px: { xs: 2, md: 4 }, pl: { md: 2 }, py: 2 }}>
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                                gap: 1,
                                                cursor: "pointer",
                                                mb: 2,
                                                width: "fit-content"
                                              }}
                                              onClick={() => navigate(-1)}
                                            >
                                              <ArrowBackIcon sx={{ fontSize: 20 }} />
                                              <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>
                                                Back
                                              </Typography>
                                            </Box>

                                            {/* ===== Step Indicator ===== */}
                                            <Box sx={{ maxWidth: "500px", mx: "auto", px: 2 }}>
                                                <Stack
                                                  direction="row"
                                                  alignItems="center"
                                                  justifyContent="space-between"
                                                  sx={{ width: "100%", mb: 4 }}
                                                >
                                                  {steps.map((label, index) => {

                                                    const isActive = index === activeStep;
                                                    const isCompleted = index < activeStep;

                                                    return (
                                                      <React.Fragment key={index}>

                                                        <Stack alignItems="center" spacing={1}>

                                                          {/* Circle */}
                                                          <Box
                                                            sx={{
                                                              width: 36,
                                                              height: 36,
                                                              borderRadius: "50%",
                                                              display: "flex",
                                                              alignItems: "center",
                                                              justifyContent: "center",
                                                              fontSize: "14px",
                                                              fontWeight: 600,
                                                              color: "#fff",

                                                              background:
                                                                isActive || isCompleted
                                                                  ? "linear-gradient(90deg, #4BA5EB, #6C63FF)"
                                                                  : "transparent",

                                                              border:
                                                                isActive || isCompleted
                                                                  ? "none"
                                                                  : "1px solid rgba(255,255,255,0.2)",
                                                            }}
                                                          >
                                                            {isCompleted ? (
                                                              <CheckIcon sx={{ fontSize: 18 }} />
                                                            ) : (
                                                              index + 1
                                                            )}
                                                          </Box>

                                                          {/* Label */}
                                                          <Typography
                                                            sx={{
                                                              fontSize: "12px",
                                                              color:
                                                                isActive || isCompleted
                                                                  ? "#fff"
                                                                  : "#A0AEC0",
                                                            }}
                                                          >
                                                            {label}
                                                          </Typography>
                                                        </Stack>

                                                        {/* Connector */}
                                                        {index !== steps.length - 1 && (
                                                          <Box
                                                            sx={{
                                                              flex: 1,
                                                              height: "1px",
                                                              mx: 0,
                                                              mt: "-18px",

                                                              background:
                                                                index < activeStep - 1
                                                                  ? "repeating-linear-gradient(to right, #4BA5EB 0 3px, transparent 3px 6px)"
                                                                  : "repeating-linear-gradient(to right, rgba(255,255,255,0.3) 0 3px, transparent 3px 6px)",
                                                            }}
                                                          />
                                                        )}
                                                      </React.Fragment>
                                                    );
                                                  })}
                                                </Stack>
                                            </Box>

                                            <Typography
                                              sx={{
                                                textAlign: "center",
                                                fontSize: { xs: "22px", md: "32px" },
                                                fontWeight: 700,
                                                color: "#fff",
                                                lineHeight: 1.3,
                                                mb: 1.5
                                              }}
                                            >
                                              Let's create your first course{" "}
                                              <span
                                                style={{
                                                  background: "linear-gradient(90deg, #4BA5EB, #6C63FF)",
                                                  WebkitBackgroundClip: "text",
                                                  WebkitTextFillColor: "transparent"
                                                }}
                                              >
                                                together
                                              </span>
                                            </Typography>

                                            <Typography
                                              sx={{
                                                textAlign: "center",
                                                fontSize: "14px",
                                                color: "#A0AEC0",
                                                maxWidth: "600px",
                                                mx: "auto",
                                                lineHeight: 1.6
                                              }}
                                            >
                                              I'll ask you a few quick questions about your expertise.
                                              Your answers help me create courses that sound like you.
                                            </Typography>


                                            {/* ── STEP 01: Digital Twin Interview ── */}
                                            <Box sx={{ mt: 4, p: 3, borderRadius: "16px", border: "1px solid #767676" }}>
                                                <Stack spacing={2}>
                                                    {/* Current AI question display */}
                                                    {isStarting ? (
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <CircularProgress size={18} sx={{ color: "#4BA5EB" }} />
                                                            <Typography color="#9CA3AF" fontSize="15px">
                                                                Loading your first question…
                                                            </Typography>
                                                        </Stack>
                                                    ) : currentQuestion ? (
                                                        <Box
                                                            sx={{
                                                                width: "100%",
                                                                textAlign: "center",
                                                                px: 2,
                                                                position: "relative",
                                                                overflow: "hidden",
                                                            }}
                                                        >
                                                            {/* Question Badge */}
                                                            <Box
                                                                sx={{
                                                                    display: "inline-flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    px: 1.8,
                                                                    py: 0.4,
                                                                    mb: 2,
                                                                    borderRadius: "999px",
                                                                    background: "rgba(59,130,246,0.12)",
                                                                    border: "1px solid rgba(75,165,235,0.35)",
                                                                    backdropFilter: "blur(8px)",
                                                                }}
                                                            >
                                                                <Typography
                                                                        sx={{
                                                                            color: "#6CB6FF",
                                                                            fontSize: "11px",
                                                                            fontWeight: 600,
                                                                            letterSpacing: "0.04em",
                                                                        }}
                                                                    >
                                                                        Question {questionIndex + 1} of {TOTAL_QUESTIONS}
                                                                </Typography>
                                                            </Box>

                                                            {/* Main Question */}
                                                            <Typography
                                                                sx={{
                                                                    color: "#fff",
                                                                    fontSize: {
                                                                        xs: "12px",
                                                                        sm: "18px",
                                                                        md: "22px",
                                                                    },
                                                                    fontWeight: 700,
                                                                    lineHeight: 1.35,
                                                                    maxWidth: "850px",
                                                                    mx: "auto",
                                                                    textAlign: "center",
                                                                }}
                                                            >
                                                                {currentQuestion}
                                                            </Typography>
                                                        </Box>
                                                    ) : null}

                                                    {/* Textarea */}
                                                    <Paper
                                                        sx={{
                                                            p: 4,
                                                            borderRadius: "18px",
                                                            position: "relative",
                                                            overflow: "hidden",
                                                            //background:
                                                            //    "radial-gradient(circle at top, rgba(25,90,200,0.25), rgba(10,14,25,0.96))",
                                                            border: "1px solid rgba(75,165,235,0.15)",
                                                            //backdropFilter: "blur(10px)",
                                                        }}
                                                    >
                                                        {/* Voice Wave + Mic */}
                                                        <Box
                                                            sx={{
                                                                display: "flex",
                                                                flexDirection: "column",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                                mb: 3,
                                                            }}
                                                        >
                                                            <Stack
                                                                direction="row"
                                                                spacing={3}
                                                                alignItems="center"
                                                                justifyContent="center"
                                                                sx={{ width: "100%" }}
                                                            >
                                                                {/* Left Wave */}
                                                                <Box
                                                                    sx={{
                                                                        width: "90px",
                                                                        height: "30px",
                                                                        background:
                                                                            "repeating-linear-gradient(to right, #4BA5EB 0 2px, transparent 2px 8px)",
                                                                        opacity: 0.7,
                                                                        borderRadius: "20px",
                                                                    }}
                                                                />

                                                                {/* Mic Button */}
                                                                <IconButton
                                                                    onClick={() =>
                                                                        isRecordingExpertise
                                                                            ? stopRecording()
                                                                            : startRecording("expertise")
                                                                    }
                                                                    className={ isRecordingExpertise ? "recording-mic-btn" : "mic-btn" }
                                                                >
                                                                    <MicNoneOutlinedIcon sx={{ color: "#fff", fontSize: "20px", }} />
                                                                </IconButton>

                                                                {/* Right Wave */}
                                                                <Box
                                                                    sx={{
                                                                        width: "90px",
                                                                        height: "30px",
                                                                        background:
                                                                            "repeating-linear-gradient(to right, #4BA5EB 0 2px, transparent 2px 8px)",
                                                                        opacity: 0.7,
                                                                        borderRadius: "20px",
                                                                    }}
                                                                />
                                                            </Stack>

                                                            <Typography
                                                                sx={{
                                                                    mt: 2,
                                                                    color: "#4BA5EB",
                                                                    fontWeight: 600,
                                                                    fontSize: "16px",
                                                                }}
                                                            >
                                                                Tap to speak
                                                            </Typography>

                                                            <Typography
                                                                sx={{
                                                                    color: "rgba(255,255,255,0.6)",
                                                                    fontSize: "13px",
                                                                    mt: 0.5,
                                                                }}
                                                            >
                                                                or type your answer
                                                            </Typography>
                                                        </Box>

                                                        {/* Textarea */}
                                                        <TextareaAutosize
                                                            ref={textareaRef}
                                                            value={expertise}
                                                            onChange={(e) => {
                                                                setExpertise(e.target.value);

                                                                if (!isViewingHistory) {
                                                                    localStorage.setItem("expertise", e.target.value);
                                                                }
                                                            }}
                                                            placeholder="Type your answer here..."
                                                            minRows={4}
                                                            style={{
                                                                width: "100%",
                                                                background: "rgba(255,255,255,0.04)",
                                                                color: "#FFFFFF",
                                                                border: "1px solid rgba(255,255,255,0.08)",
                                                                borderRadius: "14px",
                                                                padding: "16px",
                                                                fontSize: "16px",
                                                                resize: "none",
                                                                outline: "none",
                                                                boxSizing: "border-box",
                                                            }}
                                                        />

                                                        {/* Bottom Actions */}
                                                        <Stack
                                                            direction="row"
                                                            spacing={1}
                                                            sx={{
                                                                mt: 3,
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            {/* Left Side Empty Spacer */}
                                                            <Box />

                                                            {/* Previous / Submit */}
                                                            <Stack direction="row" spacing={1.5}>
                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    disabled={!canGoPrevious || isBusy}
                                                                    onClick={handleDTPrevious}
                                                                    sx={{
                                                                        color: "#D9D9D9",
                                                                        borderColor: "rgba(255,255,255,0.2)",
                                                                        borderRadius: "10px",
                                                                        px: 2,
                                                                        py: 0.8,
                                                                        textTransform: "none",
                                                                        fontWeight: 500,

                                                                        "&:hover": {
                                                                            borderColor: "#4BA5EB",
                                                                            color: "#4BA5EB",
                                                                        },

                                                                        "&.Mui-disabled": {
                                                                            opacity: 0.35,
                                                                        },
                                                                    }}
                                                                >
                                                                    {movingPrev ? (
                                                                        <CircularProgress size={16} sx={{ color: "#fff" }} />
                                                                    ) : (
                                                                        "← Previous"
                                                                    )}
                                                                </Button>

                                                                <Button
                                                                    variant="contained"
                                                                    size="small"
                                                                    disabled={isBusy}
                                                                    onClick={handleDTNext}
                                                                    sx={{
                                                                        background:
                                                                            "linear-gradient(135deg, #4BA5EB 0%, #2563EB 100%)",
                                                                        borderRadius: "10px",
                                                                        px: 2.5,
                                                                        py: 0.8,
                                                                        textTransform: "none",
                                                                        fontWeight: 600,
                                                                        minWidth: "110px",

                                                                        "&:hover": {
                                                                            background:
                                                                                "linear-gradient(135deg, #5ab0f5 0%, #3572f2 100%)",
                                                                        },
                                                                    }}
                                                                >
                                                                    {isBusy ? (
                                                                        <CircularProgress size={18} sx={{ color: "#fff" }} />
                                                                    ) : (isViewingHistory && !isParkedAtEnd) ? (
                                                                        "Next →"
                                                                    ) : (
                                                                        "Submit →"
                                                                    )}
                                                                </Button>
                                                            </Stack>
                                                        </Stack>
                                                    </Paper>

                                                    {/* Progress dots */}
                                                    {/* {sessionHistory.length > 0 && (
                                                        <Stack direction="row" spacing={0.5} justifyContent="center" mt={1}>
                                                            {sessionHistory.map((_, i) => (
                                                                <Box
                                                                    key={i}
                                                                    onClick={() => {
                                                                        setViewIndex(i);
                                                                        setCurrentQuestion(sessionHistory[i].question);
                                                                        setExpertise(sessionHistory[i].answer);
                                                                    }}
                                                                    sx={{
                                                                        width: 8,
                                                                        height: 8,
                                                                        borderRadius: "50%",
                                                                        background: viewIndex === i ? "#4BA5EB" : "#555",
                                                                        cursor: "pointer",
                                                                        transition: "background 0.2s",
                                                                    }}
                                                                />
                                                            ))}
                                                           
                                                            <Box
                                                                onClick={() => {
                                                                    setViewIndex(null);
                                                                    setExpertise(localStorage.getItem('expertise') || '');
                                                                }}
                                                                sx={{
                                                                    width: 8,
                                                                    height: 8,
                                                                    borderRadius: "50%",
                                                                    background: viewIndex === null ? "#4BA5EB" : "#555",
                                                                    cursor: "pointer",
                                                                    transition: "background 0.2s",
                                                                }}
                                                            />
                                                        </Stack>
                                                    )} */}
                                                </Stack>


                                                <Stack
                                                  direction={{ xs: "column", md: "row" }}
                                                  sx={{
                                                    mt: 3,
                                                    borderRadius: "14px",
                                                    border: "1px solid rgba(255,255,255,0.08)",
                                                    background:
                                                      "linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01))",
                                                    overflow: "hidden",
                                                  }}
                                                >
                                                  {[
                                                    {
                                                      title: "Speak naturally",
                                                      desc: "Just talk like you're having a conversation.",
                                                      icon: <SupportAgentIcon sx={{ fontSize: 18 }} />,
                                                    },
                                                    {
                                                      title: "We listen and learn",
                                                      desc: "Our AI captures what makes you unique.",
                                                      icon: <AutoFixHighIcon sx={{ fontSize: 18 }} />,
                                                    },
                                                    {
                                                      title: "Get amazing content",
                                                      desc: "We turn your answers into content people love.",
                                                      icon: <DescriptionOutlinedIcon sx={{ fontSize: 18 }} />,
                                                    },
                                                  ].map((item, index) => (
                                                    <React.Fragment key={index}>

                                                      {/* Card */}
                                                      <Stack
                                                        direction="row"
                                                        spacing={1.5}
                                                        sx={{
                                                          flex: 1,
                                                          p: 2,
                                                          alignItems: "flex-start",
                                                        }}
                                                      >
                                                        {/* Icon */}
                                                        <Box
                                                          sx={{
                                                            mt: "2px",
                                                            color: "#4BA5EB",
                                                          }}
                                                        >
                                                          {item.icon}
                                                        </Box>

                                                        {/* Text */}
                                                        <Box>
                                                          <Typography sx={{ fontSize: "13px", color: "#fff" }}>
                                                            {item.title}
                                                          </Typography>
                                                          <Typography
                                                            sx={{
                                                              fontSize: "12px",
                                                              color: "#A0AEC0",
                                                              mt: 0.5,
                                                            }}
                                                          >
                                                            {item.desc}
                                                          </Typography>
                                                        </Box>
                                                      </Stack>

                                                      {/* Divider (only between items) */}
                                                      {index !== 2 && (
                                                        <Box
                                                          sx={{
                                                            width: { xs: "100%", md: "1px" },
                                                            height: { xs: "1px", md: "auto" },
                                                            background: "rgba(255,255,255,0.08)",
                                                          }}
                                                        />
                                                      )}
                                                    </React.Fragment>
                                                  ))}
                                                </Stack>
                                            </Box>

                                            {/* Onboarding questions list */}
                                            {/* <Box sx={{ mt: 4, p: 3, borderRadius: "16px", border: "1px solid #767676" }}>
                                                <Typography fontWeight="bold" color="#fff" mb={2} fontSize={'18px'}>
                                                    The exact onboarding questions (ALL SPOKEN)
                                                </Typography>

                                                {ONBOARDING_QUESTIONS.map((q, i) => {
                                                    const answered = i < sessionHistory.length;
                                                    return (
                                                        <Stack key={i} direction="row" spacing={2} alignItems="center" mb={1.5}>
                                                            <Box
                                                                component="img"
                                                                src={bulletChecked}
                                                                alt="bullet"
                                                                sx={{
                                                                    width: 20,
                                                                    height: 20,
                                                                    flexShrink: 0,
                                                                    opacity: answered ? 1 : 0.35,
                                                                    filter: answered ? "none" : "grayscale(1)",
                                                                }}
                                                            />
                                                            <Typography sx={{ color: answered ? "#D9D9D9" : "#6B7280", fontSize: "16px", lineHeight: "24px" }}>
                                                                {q.text}
                                                            </Typography>
                                                        </Stack>
                                                    );
                                                })}
                                            </Box> */}
                                        </Box>
                                    </div>

                                </div>

                                {/* Bottom buttons */}
                                <Stack direction="row" alignItems="center" spacing={1} sx={{ mt: 2, width: "98%",   justifyContent: "flex-end"  }}>
                                    {/*<Button variant="outlined" onClick={() => {
                                        if (audioRef.current) {
                                            audioRef.current.pause();
                                            audioRef.current.currentTime = 0; // reset (optional)
                                        }
                                        localStorage.setItem('activeItem', 'blogs');
                                        navigate('/codegenie/generated-blogs');
                                        localStorage.removeItem('campaignid');
                                        localStorage.removeItem('returningtocampaign');
                                        localStorage.removeItem('sourceurl');
                                        localStorage.removeItem('campaignName');
                                        localStorage.removeItem('paymentOption');
                                        localStorage.removeItem('autoPublish');
                                        localStorage.removeItem('limitPublish');
                                        localStorage.removeItem('smUrlpublish');
                                        localStorage.removeItem('addTags');
                                        localStorage.removeItem('captureLeads');
                                        localStorage.removeItem('newsLetter');
                                        localStorage.removeItem('twitterBtn');
                                        localStorage.removeItem('fbBtn');
                                        localStorage.removeItem('pintrestBtn');
                                        localStorage.removeItem('linkedinBtn');
                                        localStorage.removeItem('video');
                                        localStorage.removeItem('twitterurl');
                                        localStorage.removeItem('fburl');
                                        localStorage.removeItem('pintresturl');
                                        localStorage.removeItem('linkedinurl');
                                        localStorage.removeItem('smUrlpublish');
                                        localStorage.removeItem('owndomain');
                                        localStorage.removeItem('ChangepayMode');
                                        localStorage.removeItem('IdChangingMode');
                                        localStorage.removeItem('PaymentSubscription');
                                        localStorage.removeItem('Authorurl');
                                        localStorage.removeItem('Authorname');
                                        localStorage.removeItem('authorDefaultCheck');
                                        localStorage.removeItem('videoTag');
                                        localStorage.removeItem('podcastUrl');
                                        localStorage.removeItem('sourcetext');
                                    }} sx={{ marginBottom: '3%', width: '8%' }}>Close</Button>&ensp;*/}
                                    <Button variant="outlined" onClick={() => {
                                        console.log('Handling create campaign...');
                                        if (audioRef.current) {
                                            audioRef.current.pause();
                                            audioRef.current.currentTime = 0; // reset (optional)
                                        }
                                        handleCreateCourseStepPrevious();

                                    }}
                                    sx={{
                                         marginBottom: '3%', width: '8%',
                                         "& .MuiButton-startIcon": {
                                           marginRight: "4px",
                                         },
                                       }}
                                       startIcon={<ArrowBackIcon sx={{ fontSize: 16 }} />}
                                    >{isUpdateLoader || isScrapcheckloading ? <CircularProgress size={24} style={{ color: '#fff' }} /> : planDetails?.payment_status === 'pending' ? 'Complete Payment' : FromEdit === 'startEditing' || localStorage.getItem('ChangepayMode') === 'true' ? 'Previous' : 'Previous'}</Button>
                                    &ensp;

                                    <Button
                                        variant="contained"
                                        disabled={!interviewDone}
                                        onClick={() => {
                                            if (isUploadLoading) {
                                                console.log('Upload in progress, skipping click actions.');
                                                return;
                                            }

                                            if (planDetails?.payment_status === 'pending') {
                                                console.log('Handling checkout...');
                                                handleCheckout(planDetails?._id);
                                            } else {
                                                console.log('Handling create campaign...');
                                                if (audioRef.current) {
                                                    audioRef.current.pause();
                                                    audioRef.current.currentTime = 0;
                                                }
                                                handleCreateCourseStep2();
                                            }
                                        }}
                                        sx={{
                                            height: "42px",
                                            px: 3,
                                            borderRadius: "8px",
                                            textTransform: "none",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            gap: 1,
                                            color: "#fff",
                                            minWidth: "140px",
                                            width: "auto",
                                            marginBottom: "3%",
                                            filter: isUploadLoading ? "blur(2px)" : "none",
                                            pointerEvents: isUploadLoading ? "none" : "auto",
                                            boxShadow: "0 2px 10px rgba(59,130,246,0.25)",
                                        }}
                                    >
                                        {isUpdateLoader || isScrapcheckloading ? (
                                            <CircularProgress size={24} style={{ color: '#fff' }} />
                                        ) : (
                                            <>
                                                {planDetails?.payment_status === 'pending'
                                                    ? 'Complete Payment'
                                                    : 'Continue'}

                                                <ArrowForwardIcon sx={{ fontSize: 18 }} />
                                            </>
                                        )}
                                    </Button>
                                </Stack>

                            </div>
                        </div>
                    </div >
                </div>
            </div>

            {/* ── Modals (all original, unchanged) ─────────────────────────── */}

            <Modal open={openpaymentInstructModal} aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
                <Box sx={{ position: "absolute" as "absolute", top: "50%", left: "50%", display: 'flex', flexDirection: 'column', alignItems: 'center', transform: "translate(-50%, -50%)", width: isMobile ? "95%" : 600, bgcolor: "background.paper", border: "2px solid #000", boxShadow: 24, pt: 2, px: 4, pb: 3 }}>
                    <PriorityHighIcon style={{ color: 'yellow', fontSize: '38px' }} />
                    <p id="child-modal-description" style={{ textAlign: 'center' }}>Please make a payment to complete your process.</p>
                    <Stack flexDirection="row">
                        <Button onClick={handleModalPayNowClick} variant="contained" sx={{ mr: 2 }}>Pay Now</Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={openGetPagesuccessModal} onClose={() => setOpenGetPageSuccessModal(false)} aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
                <Box sx={{ position: "absolute" as "absolute", top: "50%", left: "50%", display: 'flex', flexDirection: 'column', alignItems: 'center', transform: "translate(-50%, -50%)", width: isMobile ? "95%" : 600, bgcolor: "background.paper", border: "2px solid #000", boxShadow: 24, pt: 2, px: 4, pb: 3 }}>
                    <TaskAltIcon style={{ color: 'green', fontSize: '40px' }} />
                    <p id="child-modal-description" style={{ textAlign: 'center' }}>We have generated your first blogs. We will automatically generate new blogs daily per your selected plan. You can edit each blog from the My Blog page with the Edit button and Export the blogs to social media or blogging platforms with the Export button. Use the Help button on each page to learn more.</p>
                    <Stack flexDirection="row">
                        <Button variant="contained" sx={{ mr: 2 }}>Close</Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={confirmCancelSubscription} onClose={() => setConfirmCancelSubscription(false)} aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
                <Box sx={{ position: "absolute" as "absolute", top: "50%", left: "50%", display: 'flex', flexDirection: 'column', alignItems: 'center', transform: "translate(-50%, -50%)", width: isMobile ? "95%" : 800, bgcolor: "background.paper", border: "2px solid #000", boxShadow: 24, pt: 2, px: 4, pb: 3 }}>
                    <InfoIcon style={{ color: 'Orange', fontSize: '40px' }} />
                    <p id="child-modal-description" style={{ textAlign: 'center', color: '#fff' }}>When you cancel your subscription you are also canceling the hosting of your blog pages. If you would like to keep this content, please copy the content to use on a different platform. Once cancelled the content will be archived for 30 days then it will be deleted from the Traffic Monster servers and from Google Indexing.</p>
                    <Stack flexDirection="row" sx={{ gap: '10px', marginTop: '2%' }}>
                        <Button onClick={handleCancelSubscriptionClick} variant="contained" sx={{ fontWeight: 'bolder', fontSize: '17px' }}>
                            {cancellingLoader ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Continue'}
                        </Button>
                        <Button onClick={() => setConfirmCancelSubscription(false)} variant="contained" sx={{ fontWeight: 'bolder', fontSize: '17px' }}>Exit</Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={upgradeModal} disableEscapeKeyDown aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
                <Box sx={{ position: "absolute" as "absolute", top: "50%", left: "50%", display: 'flex', flexDirection: 'column', alignItems: 'center', transform: "translate(-50%, -50%)", width: isMobile ? "95%" : "40%", bgcolor: "background.paper", border: "2px solid #000", boxShadow: 24, pt: 2, px: 4, pb: 3, borderRadius: '15px', padding: '3%' }}>
                    <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                        <InfoIcon sx={{ color: '#ffcc00' }} /><br />
                        {((sourceUrl || userBusinessText) && blogcount > planDetails?.blog_count_balance) || ((sourceYoutubeUrl || uploadedvideopath) && blogcount > planDetails?.podcast_count_balance) ? 'Blog count exceeds your plan limit. Please upgrade your plan to continue.' : 'This feature is not included in your plan. Please upgrade to have access to this feature.'}
                    </Typography>
                    <Stack flexDirection="row" sx={{ display: 'flex', gap: '10px', marginTop: '1%' }}>
                        <Button onClick={() => setUpgradeModal(false)} variant="contained">Close</Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={helperPopup} disableEscapeKeyDown aria-labelledby="child-modal-title" aria-describedby="child-modal-description">
                <Box sx={{ position: "absolute" as "absolute", top: "50%", left: "50%", display: 'flex', flexDirection: 'column', alignItems: 'center', transform: "translate(-50%, -50%)", width: isMobile ? "95%" : "70%", bgcolor: "background.paper", border: "2px solid #000", boxShadow: 24, pt: 2, px: 4, pb: 3, borderRadius: '15px', padding: '3%' }}>
                    <iframe width="100%" height="500" src={helpervideosrc} title="Help Video" frameBorder="0" allow="autoplay; encrypted-media" allowFullScreen></iframe>
                    <Stack flexDirection="row">
                        <Button onClick={() => setHelperPopup(false)} variant="contained" sx={{ mr: 2, marginTop: '15%' }}>Close</Button>
                    </Stack>
                </Box>
            </Modal>

            <Modal open={topicsList} aria-labelledby="modal-title" aria-describedby="modal-description">
                <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "70%", maxWidth: 1000, bgcolor: "#36393F", border: "none", pt: 2, px: 4, pb: 3, height: '85%', maxHeight: '110vh', overflow: 'auto', borderRadius: '8px', boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)' }}>
                    <Stack width="100%">
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <Typography variant='h5' fontWeight="bold" style={{ color: '#fff' }}>Blog Topics</Typography>
                                <Typography variant='h6' fontWeight="normal" style={{ color: '#fff' }}>Below are some suggested topics to write about. You can also give us a different topic below. Our AI will write about this topic using the content you provided.</Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Box sx={{ maxHeight: '38vh', overflowY: 'auto', marginTop: '1%' }}>
                            <RadioGroup value={selectedTopic} onChange={(e) => handleTopicSelect(e.target.value)}>
                                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                                    {topics && topics?.map((topic: any, index: any) => (
                                        <Grid item xs={12} lg={12} style={{ padding: '0.5%', height: '50px' }} key={index}>
                                            <Button fullWidth color="primary"
                                                sx={{ textAlign: 'left', bgcolor: selectedTopic === topic ? '#0168B5' : 'transparent', color: selectedTopic === topic ? '#fff' : '#CBCBCB', borderColor: '#CBCBCB', '&:hover': { bgcolor: '#0168B5', color: '#fff' }, display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}
                                                onClick={() => handleTopicSelect(topic)}>
                                                <Radio checked={selectedTopic === topic} value={topic} sx={{ color: '#CBCBCB', '&.Mui-checked': { color: '#4BA5EB' } }} />
                                                {topic.replace(/-/g, ' ')}
                                            </Button>
                                        </Grid>
                                    ))}
                                </Grid>
                            </RadioGroup>
                        </Box>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Typography variant='h5' fontWeight="bold" style={{ color: '#fff', textAlign: 'center' }}>Or</Typography>
                        <TextField fullWidth variant="outlined" value={selectedTopic} onChange={(e) => setSelectedTopic(e.target.value)} sx={{ mt: 3, bgcolor: '#35353C', borderRadius: '5px' }} placeholder="Input your topic here" />
                    </Stack>
                </Box>
            </Modal>

            <Modal open={keywordsList} aria-labelledby="modal-title" aria-describedby="modal-description">
                <Box sx={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "70%", maxWidth: 1000, bgcolor: "#36393F", border: "none", pt: 2, px: 4, pb: 3, height: '87%', maxHeight: '110vh', overflow: 'auto', borderRadius: '8px', boxShadow: '0px 50px 50px rgba(0, 0, 0, 0.5)' }}>
                    <Stack width="100%">
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <Typography variant='h5' fontWeight="bold" style={{ color: '#fff' }}>Keyword Suggestions</Typography>
                                <Typography variant='h6' fontWeight="normal" style={{ color: '#fff' }}>Below are some keywords that we suggest could help you with traffic for your blog. Pick one or add your own. Keep in mind that the higher the potential traffic the more difficult it may be for your blog to rank high in google search results.</Typography>
                            </Grid>
                        </Grid>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Box sx={{ maxHeight: '38vh', overflowY: 'auto', marginTop: '1%' }}>
                            <RadioGroup value={selectedKeyword} onChange={(e) => handleKeywordSelect(e.target.value)}>
                                <Grid container spacing={1} mt={1} justifyContent="flex-start">
                                    {keywords && keywords.length > 0 ? (
                                        <Table sx={{ width: '100%', padding: '1%' }}>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Select</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold', color: '#fff', borderBottom: '1px solid #CBCBCB', background: '#4BA5EB' }}>Keyword</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {keywords.map((keyword: any, index: any) => (
                                                    <TableRow key={index} sx={{ '&:hover': { bgcolor: '#0168B5', color: '#fff' }, bgcolor: selectedKeyword === keyword.keyword ? '#0168B5' : 'transparent' }}>
                                                        <TableCell sx={{ borderBottom: '1px solid #CBCBCB' }}>
                                                            <Radio checked={selectedKeyword === keyword.keyword} value={keyword.keyword} onChange={() => handleKeywordSelect(keyword.keyword)} sx={{ color: '#CBCBCB', '&.Mui-checked': { color: '#4BA5EB' } }} />
                                                        </TableCell>
                                                        <TableCell sx={{ color: selectedKeyword === keyword.keyword ? '#fff' : '#CBCBCB', borderBottom: '1px solid #CBCBCB' }}>
                                                            {keyword.keyword}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    ) : (
                                        <div className="alert alert-info" role="alert">Keyword search failed, Please try again.</div>
                                    )}
                                </Grid>
                            </RadioGroup>
                        </Box>
                        <Divider style={{ height: '2px', backgroundColor: '#CBCBCB', marginTop: '1%' }} />
                        <Typography variant='h5' fontWeight="bold" style={{ color: '#fff', textAlign: 'center' }}>Or</Typography>
                        <TextField fullWidth variant="outlined" value={selectedKeyword} onChange={(e) => setSelectedKeyword(e.target.value)} sx={{ mt: 3, bgcolor: '#35353C', borderRadius: '5px' }} placeholder="Input your keyword here" />
                    </Stack>
                </Box>
            </Modal>

        </>
    )
}

export default New_Course;